webpackJsonp([0],{

/***/ "+6Yu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+82U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"cabecera",attrs:{"id":"cabecera"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name: 'HomeEN'}}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("7Otq"),"alt":"Mega Compañía - Logo"}})]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('nav',{staticClass:"nav-principal"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{name: 'quienesSomosEN'}}},[_vm._v("About us")])],1),_vm._v(" "),_c('li',{staticClass:"js-btn-desp mb-none"},[_vm._v("Investors "),_c('br',{staticClass:"hidden-md-down"}),_vm._v(" "),_c('ul',{staticClass:"desplegable"},[_c('li',[_c('router-link',{attrs:{"to":{name: 'regimenEN'}}},[_vm._v("Public Offering")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'infoEN'}}},[_vm._v("Financial Information")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'gobiernoEN'}}},[_vm._v("Corporate Governance")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'contactEN'}}},[_vm._v("Contact")])],1)])]),_vm._v(" "),_c('li',{staticClass:"mb-li"},[_c('router-link',{attrs:{"to":{name: 'regimenEN'}}},[_vm._v("Public Offering")])],1),_vm._v(" "),_c('li',{staticClass:"mb-li"},[_c('router-link',{attrs:{"to":{name: 'infoEN'}}},[_vm._v("Financial Information")])],1),_vm._v(" "),_c('li',{staticClass:"mb-li"},[_c('router-link',{attrs:{"to":{name: 'gobiernoEN'}}},[_vm._v("Corporate Governance")])],1),_vm._v(" "),_c('li',{staticClass:"mb-li"},[_c('router-link',{attrs:{"to":{name: 'contactEN'}}},[_vm._v("Contact")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'relacionesInstitucionalesEN'}}},[_vm._v("Institutional Relations")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'contactenosEN'}}},[_vm._v("Contact Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'proveedoresEN'}}},[_vm._v("Suppliers")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'lineaEticaEN'}}},[_vm._v("Ethics Line")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Home'}}},[_vm._v("ESP")]),_vm._v(" |\n            "),_c('router-link',{attrs:{"to":{name: 'HomeEN'}}},[_vm._v("ENG")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"burger burger-efecto mostrar"},[_c('span',{staticClass:"burger-box"},[_c('span',{staticClass:"burger-inner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+9VS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.09e5667.jpg";

/***/ }),

/***/ "+BjY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/esquema.0214b24.png";

/***/ }),

/***/ "+EDv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/20anios.16134a1.mp4";

/***/ }),

/***/ "+IIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sistemaDeGestion_vue__ = __webpack_require__("lkvx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7195ecf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sistemaDeGestion_vue__ = __webpack_require__("+Jum");
function injectStyle (ssrContext) {
  __webpack_require__("ccS1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7195ecf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sistemaDeGestion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7195ecf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sistemaDeGestion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Jum":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Sistema de Gestión Integrado")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_c('strong',[_vm._v("Compañía Mega S.A.")]),_vm._v(", implementó un Sistema de Gestión certificado el 1 de noviembre de 2002 a través de una auditoría externa. Hoy acredita el cumplimiento de los requisitos de ISO 9001:2015 (Sistemas de Gestión de la Calidad), ISO 14001:2015(Sistemas de Gestión Ambiental) y OHSAS18001:2007 (Sistemas de Gestión de la Seguridad y Salud Ocupacional en el Trabajo), aplicables a su proceso de separación, transporte, fraccionamiento y almacenamiento de los componentes líquidos del gas natural, despacho y venta de productos.")]),_vm._v(" "),_c('h5',[_vm._v("La Implementación")]),_vm._v(" "),_c('p',[_vm._v("La implementación de un Sistema Integrado de Gestión basado en las Normas ISO 9000-2000, ISO 14001-1996 e IRAM 3800-1998 fue un desafío para la Compañía, teniendo en cuenta las diferentes localizaciones, culturas y procesos operativos. Esto significó una optimización de los procesos y una mejora en los estándares de la Compañía.")]),_vm._v(" "),_c('h5',[_vm._v("La Política y el Manual de Gestión")]),_vm._v(" "),_c('p',[_vm._v("La Política de Gestión de la Compañía se apoya en Principios de Dirección alineados con los compromisos de YPF, Dow y Petrobras con la Calidad, la Seguridad, la Salud y el Medio Ambiente. Por su esmero y dedicación en la calidad de su gestión, Compañía Mega obtuvo importantes premios.")]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/politica.png","target":"_blank"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("VER POLITICA DE GESTIÓN")])]),_vm._v(" "),_c('p',[_vm._v("Como parte de este proceso la Compañía emitió su Manual de Gestión y realizó su comunicación formal en la Organización.")]),_vm._v(" "),_c('div',{staticClass:"cont-pdf"},[_c('a',{attrs:{"href":"static/pdf/Certificado-9001-2015.pdf","target":"_blank"}},[_c('img',{staticClass:"pdf",attrs:{"src":__webpack_require__("1jms"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/Certificado-14001-2015.pdf","target":"_blank"}},[_c('img',{staticClass:"pdf",attrs:{"src":__webpack_require__("nHuZ"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/Certificado-18001-2007.pdf","target":"_blank"}},[_c('img',{staticClass:"pdf",attrs:{"src":__webpack_require__("XsLF"),"alt":""}})])])])])])]),_vm._v(" "),_c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h2',[_vm._v("Premio Nacional a la calidad 2006")]),_vm._v(" "),_c('p',[_vm._v("Como consecuencia de su esmero y dedicación en la calidad de su gestión, Compañía Mega S.A. fue galardonada en el año 2006 con el Premio Nacional a la Calidad que distingue la excelencia en calidad de gestión. La entrega del premio se efectuó en un acto llevado a cabo en la Casa de Gobierno con la presencia del Sr. Presidente de la Nación, Néstor Kirchner, quien hiciera entrega del mismo.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("Z+QK"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("El Premio Nacional a la Calidad es un sistema de evaluación integrado, a partir de un modelo ideal de empresa de alta competencia, y es otorgado anualmente por la Nación Argentina a través del Presidente de la Nación. Asimismo, es organizado y administrado por la Fundación Premio Nacional a la Calidad, creada para ese fin.")]),_c('p'),_c('p',[_vm._v("Fue instituido por la ley 24.127 en 1994, con el objetivo de promover el desarrollo de los procesos y sistemas destinados al mejoramiento continuo de la calidad en los productos y servicios, a fin de fomentar la modernización y competitividad del sector empresario.")]),_vm._v(" "),_c('p',[_vm._v("Pueden concursar pequeñas, medianas o grandes empresas, tanto de servicios como de producción de bienes, que tengan como mínimo una continuidad operativa de 3 años en el país.")]),_vm._v(" "),_c('p',[_vm._v("La evaluación de las organizaciones está a cargo de una junta de evaluadores compuesta por jueces y examinadores seleccionados por concurso abierto que actúa en forma independiente de la Fundación.")]),_c('p'),_c('p',[_vm._v("Implica un riguroso proceso, que se extiende a lo largo de 4 meses y consta de 3 etapas bien diferenciadas: en la primera, un grupo no menor de 5 examinadores estudian en forma independiente las fortalezas y los aspectos a mejorar de los 28 criterios del premio, aplicables a cada postulante, y le asignan puntaje. En la segunda etapa, estos examinadores se reúnen para consensuar los resultados obtenidos para cada empresa. Por último, en la tercera etapa, las empresas seleccionadas reciben la visita del equipo de examinadores.")]),_vm._v(" "),_c('p',[_vm._v("Examinadores y jueces realizan esta tarea ad honorem y cada empresa evaluada insume en promedio 765 horas profesionales que se plasman en el informe de retroalimentación que reciben las empresas participantes, independientemente del resultado del concurso.")]),_vm._v(" "),_c('p',[_vm._v("El premio se instauró en el año 1992, y entre los ganadores se encuentran empresas de diferentes rubros y categorías tales como Unilever de Argentina S.A. (División Limpieza y Cuidado Personal), Hotel Intercontinental, Telecom Personal S.A., Nextel Argentina, 3M Argentina, Siderar, División Lubricantes de Repsol YPF, Taranto San Juan S.A. y Volkswagen Argentina Centro Industrial Córdoba, entre otras.")]),_vm._v(" "),_c('a',{staticClass:"link-azul",attrs:{"href":"http://www.fundece.org.ar","target":"_blank"}},[_vm._v("www.FUNDECE.org.ar")])])])])]),_vm._v(" "),_c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h2',[_vm._v("Premio Oro Iberoamericano a la calidad año 2008")]),_vm._v(" "),_c('p',[_vm._v("El Premio Iberoamericano de la Calidad es un Programa Oficial de la Cumbre Iberoamericana de Jefes de Estado y de Gobierno, basado en el Modelo Iberoamericano de Excelencia en la Gestión y gestionado por FUNDIBEQ.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("5Ifx"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("Al Premio Iberoamericano de la Calidad pueden acceder las Organizaciones Iberoamericanas tanto públicas como privadas de Iberoamérica.")]),_vm._v(" "),_c('p',[_vm._v("Este Premio es desarrollado gracias a la colaboración de los Premios Nacionales y Regionales Asociados de los diferentes países de Iberoamérica y tiene por objeto:")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Reconocer la Calidad de las organizaciones premiadas en el contexto internacional y con ello contribuir a que la Comunidad Iberoamericana sea considerada un entorno de Calidad, donde encontrar los mejores proveedores, aliados y oportunidades de inversión.")]),_vm._v(" "),_c('li',[_vm._v("Estimular el desarrollo de las organizaciones iberoamericanas, ofreciendo un Modelo que permite compararse con organizaciones excelentes a nivel internacional.")]),_vm._v(" "),_c('li',[_vm._v("Promover la Auto-evaluación y la focalización hacia la satisfacción de las necesidades y expectativas del cliente y de las partes interesadas.")])])]),_vm._v(" "),_c('p',[_vm._v("Compañía Mega S.A. fue galardonada en el año 2008 con el PREMIO ORO IBEROAMERICANO A LA CALIDAD, en la categoría PRIVADA MEDIANA. Esta premiación nos llena de orgullo y nos refuerza en nuestro constante compromiso con la calidad de toda nuestra gestión.")]),_vm._v(" "),_c('a',{staticClass:"link-azul",attrs:{"href":"http://www.fundibeq.org","target":"_blank"}},[_vm._v("www.FUNDIBEQ.org")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+QH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__ = __webpack_require__("ib2g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31407ac4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__("ZCOF");
function injectStyle (ssrContext) {
  __webpack_require__("Wr/z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31407ac4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31407ac4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+fWr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fundibeq_premio.4097b9d.jpg";

/***/ }),

/***/ "+u0w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabecera'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pie')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("8b4B"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Régimen de Oferta Pública")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"caja"},[_c('p',[_vm._v("COMPAÑÍA MEGA S.A. ingresó al Régimen de Oferta Pública de la Comisión Nacional de Valores (CNV) conforme resolución RESFC-2019-20543-APN-DIR#CNV de fecha 7 de noviembre de 2019."),_c('br'),_vm._v("\n          A través del "),_c('a',{attrs:{"target":"_blank","href":"https://www.cnv.gov.ar/SitioWeb/Empresas"}},[_vm._v("sitio web oficial de la CNV")]),_vm._v(" (*) podrá consultarse la información relacionada con la sociedad y el mercado de capitales.\n\n          ")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("(*) El hipervínculo conduce al sitio web de la CNV, ajeno a la Compañía, por lo que Compañía Mega S.A. no puede garantizar la información contenida en el mismo y no se responsabiliza por suplementar, actualizar o corregir dicha información.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/LYx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_enviarCV_en_vue__ = __webpack_require__("n//S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b430aa62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_enviarCV_en_vue__ = __webpack_require__("kqvE");
function injectStyle (ssrContext) {
  __webpack_require__("w6jg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b430aa62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_enviarCV_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b430aa62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_enviarCV_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0/OY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestrasPlantas_en_vue__ = __webpack_require__("cGSs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55bc2ec9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestrasPlantas_en_vue__ = __webpack_require__("GgKY");
function injectStyle (ssrContext) {
  __webpack_require__("A/h3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55bc2ec9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestrasPlantas_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55bc2ec9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestrasPlantas_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "07yY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Ariba")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"caja"},[_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"href":"https://service.ariba.com/Supplier.aw/124996083/aw?awh=r&awssk=C56809bX&dard=1"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("Acceso a ARIBA Network")])])]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"href":"static/pdf/MEGA - Manual Ariba Proveedores.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("Manual de proveedores")])])]),_vm._v(" "),_c('p',[_vm._v("En caso de dudas de navegación del portal Ariba, por favor, acceda a nuestro Centro de Ayuda ubicado en la esquina superior derecha de su cuenta.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Cg+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "0eQu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video2.227b174.mp4";

/***/ }),

/***/ "0hkm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CabeceraEN__ = __webpack_require__("DPbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PieEN__ = __webpack_require__("LKlI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'info',
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_1__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_2__components_PieEN__["a" /* default */]
  }
});



__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.profile .box').toggleClass('open');
  });
});

/***/ }),

/***/ "1IHV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormContactenos',
  data: function data() {
    return {
      nombre: '',
      tel: '',
      email: '',
      consulta: '',
      estado: '',
      mensajeEstado: ''
    };
  },


  computed: {
    claseEstado: function claseEstado() {
      return 'alert alert-' + this.estado;
    }
  },

  methods: {
    enviarFormulario: function enviarFormulario(evento) {
      var _this = this;

      this.$http.get('http://synapsis.com.ar/test/formulario/mega.php', {
        params: {
          token: 'DrKrxX0Gjl243B38QDjg4EgppGDNh8vl',
          SenderName: this.nombre,
          tel: this.tel,
          SenderAddress: this.email,
          consulta: this.consulta
        },
        before: function before(request) {
          this.estado = 'info';
          this.mensajeEstado = 'Enviando...';
        }
      }).then(function (response) {
        if (response.body.error !== 'false') {
          _this.estado = 'success';
          _this.mensajeEstado = response.body.mensaje;

          // Borro los datos del form
          _this.nombre = '';
          _this.tel = '';
          _this.email = '';
          _this.consulta = '';
        } else {
          _this.estado = 'danger';
          _this.mensajeEstado = response.body.mensaje;
        }
      }, function (response) {
        _this.estado = 'danger';
        _this.mensajeEstado = response.body.mensaje;
      });
    }
  }
});

/***/ }),

/***/ "1cIH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.5e7c719.png";

/***/ }),

/***/ "1jms":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certificado-9001-2015.2a8b2d5.jpg";

/***/ }),

/***/ "2QV4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3c.3148ce0.png";

/***/ }),

/***/ "2U+m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certificado-14001-2015.4656c66.jpg";

/***/ }),

/***/ "2akJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-plantas.28afe01.jpg";

/***/ }),

/***/ "2bts":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Feb-2019-organigrama.83e470c.jpg";

/***/ }),

/***/ "2mb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabecera'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('pie')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("7zM0"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Gobierno Corporativo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"caja"},[_c('h5',[_vm._v("Gobierno corporativo")]),_vm._v(" "),_c('p',[_vm._v("En COMPAÑÍA MEGA priorizamos y alentamos la incorporación de las mejores prácticas de Gobierno Corporativo, porque estamos convencidos de que éstas, son herramientas clave para coadyuvar a la seguridad económica y jurídica, tanto de los inversores, como de la Compañía, de sus accionistas, empleados y de la sociedad en general, adicionando transparencia e integridad a nuestra gestión.\n        "),_c('br'),_c('br'),_vm._v("\n          Actualmente, las prácticas de Gobierno Corporativo de COMPAÑÍA MEGA están reguladas por el Estatuto de la Compañía, el Código de Ética, las Políticas Internas, la Ley General de Sociedades N° 19.550, la Ley de Mercado de Capitales N°26.831, las normas de la Comisión Nacional de Valores, y las demás normas del ordenamiento legal vigente que resultan de aplicación.\n\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("La Línea Ética de Compañía Mega S.A. es una herramienta diseñada para facilitar la denuncia de conductas contrarias al Código de Ética. La misma se encuentra disponible todos los días, las 24 hs. y es administrada por la firma BDO, tercero independiente que garantiza la confidencialidad, anonimato y transparencia del sistema de recepción de denuncias.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("KMsP"),"alt":"Banner de las plantas de Mega Cia."}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h4',[_vm._v("Canales de Denuncia")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Teléfono: 0800-34-LINEA (54632)")]),_vm._v(" "),_c('li',[_vm._v("Página web: "),_c('a',{attrs:{"href":"http://www.bdolineaetica.com/ciamega","target":"_blank"}},[_vm._v("www.bdolineaetica.com/ciamega")])]),_vm._v(" "),_c('li',[_vm._v("Email: "),_c('a',{attrs:{"href":"mailto:ciamega@bdolineaetica.com"}},[_vm._v("ciamega@bdolineaetica.com")])]),_vm._v(" "),_c('li',[_vm._v("Carta: Rondeau 2664 PB, C1262ABH CABA")]),_vm._v(" "),_c('li',[_vm._v("Entrevista personal: Maipú 942 PB, C1006ACN CABA")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descargas"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('a',{attrs:{"href":"static/pdf/manual-del-anuciante-mega.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("C2P4"),"alt":""}}),_c('span',[_vm._v("DESCARGAR EL MANUAL")])]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/Mega_ManualDeEtica_Mayo2021 (1).pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("C2P4"),"alt":""}}),_c('span',[_vm._v("DESCARGAR EL CÓDIGO DE ÉTICA")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2qBd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_medioAmbiente_en_vue__ = __webpack_require__("xGDn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7097f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_medioAmbiente_en_vue__ = __webpack_require__("m2mK");
function injectStyle (ssrContext) {
  __webpack_require__("doJf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e7097f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_medioAmbiente_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7097f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_medioAmbiente_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2tUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PieEN__ = __webpack_require__("LKlI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CabeceraEN__ = __webpack_require__("DPbz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lineaEticaEN',
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_1__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_0__components_PieEN__["a" /* default */]
  }
});



/***/ }),

/***/ "3Id5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organizacion_vue__ = __webpack_require__("ExI6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85daeeaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Organizacion_vue__ = __webpack_require__("iszN");
function injectStyle (ssrContext) {
  __webpack_require__("hoSU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85daeeaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organizacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85daeeaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Organizacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3aAj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PieEN'
});

/***/ }),

/***/ "3hEQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3iIt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_regimen_en_vue__ = __webpack_require__("dL44");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_306cfdce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_regimen_en_vue__ = __webpack_require__("OD3p");
function injectStyle (ssrContext) {
  __webpack_require__("tUJ8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-306cfdce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_regimen_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_306cfdce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_regimen_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3kaA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contactenos_form_contactenos__ = __webpack_require__("4Hn3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Cabecera__ = __webpack_require__("SDdG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contactenos',
  components: {
    FormContactenos: __WEBPACK_IMPORTED_MODULE_0__components_contactenos_form_contactenos__["a" /* default */],
    Cabecera: __WEBPACK_IMPORTED_MODULE_1__components_Cabecera__["a" /* default */]
  }
});

/***/ }),

/***/ "3urk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certificado-18001-2007.748f86b.jpg";

/***/ }),

/***/ "46l/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Hn3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_contactenos_vue__ = __webpack_require__("1IHV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09760564_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_contactenos_vue__ = __webpack_require__("ePvE");
function injectStyle (ssrContext) {
  __webpack_require__("wmBQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09760564"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_contactenos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09760564_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_contactenos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4aQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabecera'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('form-contactenos')],1)])])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("L27D"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Contactanos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banda-azul"},[_c('div',{staticClass:"texto"},[_c('h1',[_vm._v("Trabajá con nosotros")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:empleos@ciamega.com"}},[_vm._v("Enviar CV")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4iyI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_vue__ = __webpack_require__("Cszk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59280d46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_info_vue__ = __webpack_require__("VphK");
function injectStyle (ssrContext) {
  __webpack_require__("crb6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59280d46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59280d46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4jPn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/linea-etica.a90051c.jpg";

/***/ }),

/***/ "4nLF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-plantas.28afe01.jpg";

/***/ }),

/***/ "5Ifx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fundibeq_premio.4097b9d.jpg";

/***/ }),

/***/ "5lMt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("FAKZ"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Institutional Relations")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("At COMPAÑIA MEGA S.A. we devote our best efforts to establish long-term and strong\nrelationships with our stakeholders in accordance with our Management Manual. For this\npurpose, we have developed different community outreach programs. Our external\nstakeholders include clients, suppliers, neighbors, surface rights owners, public and private\nentities, nonprofit associations, NGOs, and the media, among others.")]),_vm._v(" "),_c('h5',[_vm._v("“Acompañando a Crecer” - Scholarship Program")]),_vm._v(" "),_c('p',[_vm._v("\nIn 2003 MEGA S.A. launched a College Scholarship Program for Ingeniero White high-\nschool graduates. This program, which awards 5 scholarships every year, is run in close\ncollaboration with Foundation Cecilia Grierson, which provides assistance with scholarship\napplications and assessments.")]),_vm._v(" "),_c('h6',[_vm._v("APPLICATION REQUIREMENTS")]),_vm._v(" "),_c('ul',[_c('li',[_c('img',{attrs:{"src":__webpack_require__("Q2N1"),"alt":""}}),_vm._v("Graduating from a high school located in the district of Ingeniero White.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("Q2N1"),"alt":""}}),_vm._v("Pursue and complete undergraduate education in the city of Bahía Blanca.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("Q2N1"),"alt":""}}),_vm._v("Having a high-school grade point average of ≥ 8.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("Q2N1"),"alt":""}}),_vm._v("Not holding other scholarships or internships.")])]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/reglamento2021.docx"}},[_vm._v("SEE SCHOLARSHIP RULES")]),_vm._v(" "),_c('div',{staticClass:"cont-pdf"},[_c('img',{staticClass:"img",attrs:{"src":__webpack_require__("AX/Z"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"video"},[_c('h1',[_vm._v("20 years Mega")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-12 col-md-10"},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("On April 1, 2021 we turn 20 years old and to celebrate it we chose to tell our story in the voice of its protagonists. Past, present and future of the company in the testimonies of the people who are part of Mega's history and present. In 2001 we began our operation and our goal of adding value to energy to take it to different parts of the country, the region and the world.  #20AñosMega #LaVozDeNuestraHistoria #AgregamosValorALaEnergía")])]),_vm._v(" "),_c('video',{attrs:{"controls":"","playsinline":"","src":__webpack_require__("+EDv")}})])]),_vm._v(" "),_c('div',{staticClass:"banda-azul"},[_c('div',{staticClass:"texto"},[_c('h1',[_vm._v("Follow the news and updates of our company in our Social Networks")]),_vm._v(" "),_c('div',{staticClass:"rrss"},[_c('a',{attrs:{"target":"_blank","href":"https://ar.linkedin.com/company/ciamega"}},[_c('img',{attrs:{"src":__webpack_require__("hBfA"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/channel/UCJIz0KFkNtsea_iY-H2b2cQ"}},[_c('img',{attrs:{"src":__webpack_require__("S2so"),"alt":""}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5y+8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("w7kl"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("ETHICS LINE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("MEGA S.A.'s Ethics Line is a tool designed to report Code of Ethics violations. This line is available 24/7 and is managed by a third-party firm, BDO, to guarantee confidentiality, anonymity, transparency.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("o3KE"),"alt":"Banner de las plantas de Mega Cia."}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h4',[_vm._v("Whistleblower Channels")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Telephone: 0800-34-LINEA (54632)")]),_vm._v(" "),_c('li',[_vm._v("Webpage: "),_c('a',{attrs:{"href":"http://www.bdolineaetica.com/ciamega","target":"_blank"}},[_vm._v("www.bdolineaetica.com/ciamega")])]),_vm._v(" "),_c('li',[_vm._v("Email: "),_c('a',{attrs:{"href":"mailto:ciamega@bdolineaetica.com"}},[_vm._v("ciamega@bdolineaetica.com")])]),_vm._v(" "),_c('li',[_vm._v("Mailing Address: Rondeau 2664 PB, C1262ABH CABA")]),_vm._v(" "),_c('li',[_vm._v("Personal Interviews: Maipú 942 PB, C1006ACN CABA")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descargas"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('a',{attrs:{"href":"static/pdf/manual-del-anuciante-mega.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("U2vJ"),"alt":""}}),_c('span',[_vm._v("DOWNLOAD MANUAL")])]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/Mega_ManualDeEtica_Mayo2021 (1).pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("U2vJ"),"alt":""}}),_c('span',[_vm._v("DOWNLOAD CODE OF ETHICS")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ze/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/introMEGA.3cf8f75.mp4";

/***/ }),

/***/ "65zn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestraEmpresa_en_vue__ = __webpack_require__("EUJ2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_221200ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestraEmpresa_en_vue__ = __webpack_require__("KZkt");
function injectStyle (ssrContext) {
  __webpack_require__("e8hY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-221200ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestraEmpresa_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_221200ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestraEmpresa_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6MAX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",attrs:{"id":"footer"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row "},[_c('div',[_c('div',{staticClass:"datos"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("U9Kg"),"alt":"Mega Compañía - Logo"}}),_vm._v(" "),_c('div',{staticClass:"rrss"},[_c('a',{attrs:{"target":"_blank","href":"https://ar.linkedin.com/company/ciamega"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("kzQl"),"alt":"Mega Compañía - Logo"}})]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/channel/UCJIz0KFkNtsea_iY-H2b2cQ"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("bDnV"),"alt":"Mega Compañía - Logo"}})])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"datos"},[_c('h4',[_vm._v("BUENOS AIRES")]),_vm._v(" "),_c('p',[_vm._v("San Martín 344, piso 27º")]),_vm._v(" "),_c('p',[_vm._v("(C1004AAH)")]),_vm._v(" "),_c('p',[_vm._v("Ciudad Autónoma de Buenos Aires")]),_vm._v(" "),_c('p',[_vm._v("Tel: "),_c('a',{attrs:{"href":"tel:+541128210300"}},[_vm._v("(54 11) 2821-0300")])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"datos"},[_c('h4',[_vm._v("PLANTA NEUQUEN")]),_vm._v(" "),_c('p',[_vm._v("Ruta Provincial 51, km 85")]),_vm._v(" "),_c('p',[_vm._v("(Q8300XAD) Loma La Lata")]),_vm._v(" "),_c('p',[_vm._v("Provincia de Neuquén")]),_vm._v(" "),_c('p',[_vm._v("Tel: "),_c('a',{attrs:{"href":"tel:+542994904400"}},[_vm._v("(54 299) 490-4400")])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"datos"},[_c('h4',[_vm._v("PLANTA BAHIA BLANCA")]),_vm._v(" "),_c('p',[_vm._v("Av. del Desarrollo Presidente Frondizi s/n")]),_vm._v(" "),_c('p',[_vm._v("(B8000XAU) Puerto Galván")]),_vm._v(" "),_c('p',[_vm._v("Provincia de Buenos Aires")]),_vm._v(" "),_c('p',[_vm._v("Tel: "),_c('a',{attrs:{"href":"te:+542914037650"}},[_vm._v("(54 291) 403-7650")])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"datos"},[_c('h4',[_vm._v("Línea Emergencias Poliducto")]),_vm._v(" "),_c('p',[_vm._v("Para informar alguna irregularidad o realizar una consulta acerca de nuestro poliducto llamar a nuestra línea gratuita las 24 horas, los 365 días del año: "),_c('strong',[_c('a',{attrs:{"href":"te:+5408009998050"}},[_vm._v("0-800-999-8050")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row disp"},[_c('p',{staticClass:"pata"},[_vm._v("2021© Todos los derechos reservados")]),_vm._v(" "),_c('a',{staticClass:"patas",attrs:{"href":"https://synapsis.com.ar/"}},[_c('img',{attrs:{"src":__webpack_require__("SDkT"),"alt":""}}),_vm._v("Synapsis")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6rzM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6sux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nuestrosComienzos',
  data: function data() {
    return {
      msg: 'Nuestros comienzos'
    };
  }
});

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "7Q4y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.5bd8532.jpg";

/***/ }),

/***/ "7XvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabecera'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('pie')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("avom"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("LÍNEA ÉTICA")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("La Línea Ética de Compañía Mega S.A. es una herramienta diseñada para facilitar la denuncia de conductas contrarias al Código de Ética. La misma se encuentra disponible todos los días, las 24 hs. y es administrada por la firma BDO, tercero independiente que garantiza la confidencialidad, anonimato y transparencia del sistema de recepción de denuncias.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("Znap"),"alt":"Banner de las plantas de Mega Cia."}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h4',[_vm._v("Canales de Denuncia")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Teléfono: 0800-34-LINEA (54632)")]),_vm._v(" "),_c('li',[_vm._v("Página web: "),_c('a',{attrs:{"href":"http://www.bdolineaetica.com/ciamega","target":"_blank"}},[_vm._v("www.bdolineaetica.com/ciamega")])]),_vm._v(" "),_c('li',[_vm._v("Email: "),_c('a',{attrs:{"href":"mailto:ciamega@bdolineaetica.com"}},[_vm._v("ciamega@bdolineaetica.com")])]),_vm._v(" "),_c('li',[_vm._v("Carta: Rondeau 2664 PB, C1262ABH CABA")]),_vm._v(" "),_c('li',[_vm._v("Entrevista personal: Maipú 942 PB, C1006ACN CABA")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descargas"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('a',{attrs:{"href":"static/pdf/manual-del-anuciante-mega.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("IJo5"),"alt":""}}),_c('span',[_vm._v("DESCARGAR EL MANUAL")])]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/Mega_ManualDeEtica_Mayo2021 (1).pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("IJo5"),"alt":""}}),_c('span',[_vm._v("DESCARGAR EL CÓDIGO DE ÉTICA")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7d7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Esquema del proceso")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("El  proceso se divide en dos instalaciones principales: una Planta Separadora y una Planta Fraccionadora, conectadas por un ducto de 600km con una estación de bombeo intermedia, que atraviesa cuatro provincias")]),_vm._v(" "),_c('img',{staticClass:"img-fluid img-esq",attrs:{"src":__webpack_require__("wSQa"),"alt":"Esquema del proceso de Mega"}}),_vm._v(" "),_c('h4',[_vm._v("PLANTA SEPARADORA LOMA LA LATA")]),_vm._v(" "),_c('p',[_vm._v("Ubicada en el corazón del yacimiento de gas natural argentino, Loma La Lata, provincia de Neuquén.")]),_vm._v(" "),_c('h6',[_vm._v("Separación del gas de entrada:")]),_vm._v(" "),_c('p',[_vm._v("El gas que ingresa a la planta es enviado a un separador de alimentación a fin de eliminar cualquier partícula extraña previo a su envío al sector de deshidratación.")]),_vm._v(" "),_c('h6',[_vm._v("Deshidratación:")]),_vm._v(" "),_c('p',[_vm._v("Para separar los componentes ricos, la corriente del gas natural que entra a la Planta Separadora se somete a un proceso de enfriamiento. Sin embargo, para poder realizar este proceso, es condición precedente quitarle al gas el agua que trae consigo. La etapa de deshidratación deja al gas con un contenido de agua menor a una parte por millón. El sistema de deshidratación consta de cinco lechos: cuatro operativos y uno de regeneración.")]),_vm._v(" "),_c('h6',[_vm._v("Recuperación:")]),_vm._v(" "),_c('p',[_vm._v("El gas deshidratado se divide en dos corrientes para ingresar cada una a un tren de separación criogénica. El proceso consiste en una expansión hasta los 26Kg/cm2, disminuyendo la temperatura del gas hasta los -97°C. En estas condiciones ingresa a la torre demetanizadora, separando al gas natural en sus diferentes componentes. De esta manera el etano, propano, butano y gasolina natural se condensan y son recogidos en estado líquido por el fondo de la torre (NGL). El metano residual, todavía en estado gaseoso, es recuperado por el tope de la torre para su acondicionamiento e inyección a gasoductos. El sistema de separación permite una eficiencia de hasta 88% en la recuperación de etano y superior a 96% en la recuperación de propano.")]),_vm._v(" "),_c('h6',[_vm._v("Estación de compresión de gas:")]),_vm._v(" "),_c('p',[_vm._v("El gas residual obtenido de la demetanización, mayoritariamente metano, es recomprimido a fin de inyectarlo al gasoducto. Para este fin la planta cuenta con un sistema de compresión de 93000hp que descarga a un cabezal desde donde se alimentan los principales gasoductos troncales del país.")]),_vm._v(" "),_c('h4',[_vm._v("POLIDUCTO")]),_vm._v(" "),_c('p',[_vm._v("El objetivo del poliducto es el de transportar el líquido recuperado (que mayoritariamente es etano, propano, butano y gasolina natural) desde la planta de Loma La Lata hasta la planta de Bahía Blanca.")]),_vm._v(" "),_c('h4',[_vm._v("PLANTA FRACCIONADORA DE BAHÍA BLANCA")]),_vm._v(" "),_c('p',[_vm._v("En la planta se recibe el líquido recuperado en Loma La Lata y transportado a través de 600 km de ducto, y se fracciona el etano, propano, butano y gasolina natural mediante procesos de destilación (deetanización, depropanización y debutanización).")]),_vm._v(" "),_c('h6',[_vm._v("Deetanización, Depropanización y Debutanización:")]),_vm._v(" "),_c('p',[_vm._v("El líquido recuperado en Loma La Lata que ingresa a este sector de destilación debe ser precalentado para garantizar una temperatura constante de alimentación a la deetanizadora. Este precalentamiento se lleva a cabo intercambiando calor con gasolina natural, que a su vez es pre-enfriada antes de su almacenamiento. Durante la deetanización se separa el etano del líquido formado por propano, butano y gasolina natural, para su posterior tratamiento. Esta mezcla líquida es acondicionada para llevar a cabo la depropanización en la que se obtiene el propano y una mezcla líquida constituida por butano y gasolina natural que nuevamente es acondicionada para ingresar a la columna de destilación donde se realiza la debutanización. En esta columna de destilación se obtienen el butano y la gasolina natural. Tanto el propano como el butano y la gasolina natural son acondicionados térmicamente para su almacenamiento.")]),_vm._v(" "),_c('h6',[_vm._v("Tratamiento de etano:")]),_vm._v(" "),_c('p',[_vm._v("El sector de tratamiento de etano consiste en una unidad de remoción de dióxido de carbono. La remoción del dióxido de carbono se basa en una tecnología con aminas que deja el etano prácticamente libre de dióxido de carbono. El anhídrido carbónico se acondiciona en una etapa posterior para eliminar el ácido sulfhídrico y se comercializa parcialmente.")]),_vm._v(" "),_c('h6',[_vm._v("Sistema de refrigeración de productos:")]),_vm._v(" "),_c('p',[_vm._v("El sistema de refrigeración de productos proporciona el frío requerido para el almacenamiento de propano, butano, gasolina natural y la condensación de la deetanización.")]),_vm._v(" "),_c('h6',[_vm._v("Almacenamiento de productos:")]),_vm._v(" "),_c('p',[_vm._v("El sector de almacenamiento está compuesto por tanques de propano, butano y gasolina natural. Todos los productos se almacenan a presión atmosférica. La gasolina natural se almacena en tanques de techo flotante, mientras que el propano y el butano se almacenan en tanques refrigerados.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("GRSW"),"alt":"Planta de Mega Cia"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7zM0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.5977a7b.jpg";

/***/ }),

/***/ "8/3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8IwT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjJERjU4Nzk5RThDMzExRUJCOEI0QzRFMERFNjRCNkQ0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjJERjU4NzlBRThDMzExRUJCOEI0QzRFMERFNjRCNkQ0Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MkRGNTg3OTdFOEMzMTFFQkI4QjRDNEUwREU2NEI2RDQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MkRGNTg3OThFOEMzMTFFQkI4QjRDNEUwREU2NEI2RDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6PKZoqAAAG/klEQVR42tRaaWxUVRT+7nvzZmmnnZm2dIFuQIuUpUAxUWhBxZ1VggsoosSQoCZG4/pDg/EHiRrLL000UWPAoAZQNFEIApa1shQQKkuXKaW0DtOWTjudpfMWz+2MBIZO1xkYT/LNnTdz58333Xvucs59DFGyg4m5BVTcSZhEyCakEKyEAKGLcIVQTzhDqCztbmyPxv+yERDmvy0jrCAsCpEeip0kbCN8S2Lqb5kAIi5RsYrwBmFilDpwB+FDEvJHTAUQed7S5YQCxMa4kFdJyPmoCiDiNio+JzyB2JufsI7wMQlRRyyAyM+g4idCLm6t7SQsJxEdwxZA5OdTsYVgwu0x7koPkIimIQsg8otD5CXcXrMT5kYSwSKQL6Vi121s+XA7R5jVlzuxPsjz+fw4IR3xZXyGWhA+sIUw8vx6YxyS5/ZIaO1BRAFkawn3In7tA2rkwj5dSNmflqZ4WQU0GOJYADQFVYb5zif/u9Zd991bokmbhPi38dTYZeKc1gPXXIg+sFDxIv4/9k74GHiWYB72knlCQU3zLRUwnxo993oXWjnUO3h8AuxOM07V+1BBO/wMm4TJ2TLmTZdgTfBA0qmxFMBCnNfrSEkWvblr0MT9Er7cqcKSKKCqxoVXH9bwd42ATH0XZuZLeO9rH6YX6JFg0mPVPF8sRTzGBXAXmjeUX+07a0WC7EXSjgA8F/2ofE0HZlfhOy3i9zcZbG4ZWX/24NzZLjg7YzqhzeRjlwuYNZRfleR3IeAX0aBnEMlNThbJ6JL8sMsaLk8KQNNUNIga0qmHUs3+WArg3O/mL1MGqun2aajYr6C1jYhZfVhwD0NTgg8mmxEdOQypGQbY8hgu0Tjo0ItQcgJ4aYUIge7e2KBi92GFhMVExGQuYNxAtfbvVHDqsogt25SgoBZgYYkOZncPLOf9EGoBoz8fOeIY5I/NxeJFd8DhSe8lvXsvcPSUhrr6mAzqcXwWyhyolqUISL4SQIoxuHDXlkvwBDR0jZExu9mEBIsIy9oN8F5tR/2xSlTYU1BSbEAOWw9vVgBpBgYpSYiFgAxhMPv90Wm0QU1cDZut+Npne6e50WAO4PB0T+912+kasEOXsMQ/DcZ2AwQxSHhK8TPoYQ8hJy0mAoyDuqvBQD5uzYbXKaCzM+jMPSwTktkKn5AW3EsZdBANJjQLXujNRvJ/BkeLBn+HCZqQ1DseYmCSbqAaTXaa57f+A4NUDiFTxb6vdVDJnQWmgy8ggtHsc8atQ8rxI5CzJ8KqJCPLYoHL2YKWzQK05G0o1HlRQSFJ6Qu0copRFeATQhmziKanmMzlIMJPvwtHZwbmfiITeUB1XobsGQ3UK9g6cza+a7wAf08b6sbSmmBUkZhCI+xBBazoYVQnz0En9YYY/V5w8B5o6i+ASc9kGL/Ghr+270F3VTv8tP5Z1shYRa4hB+zY5UqFKHrgFPOgHvgKqROMtOcl0XsYdMUMF37YD3l8Ju6jRY6xqAto4m1S3V+NlmYVR8pbwf2m+JVJGDWKiCVqEAwEScP0wlYU1joxz14F62gfuUwHhLwOaF0uTJ3FMG71/ZAcLmxcJ8diDFRzAUf7q5FCs4elzIQxyx5EUurNW4P0LIbnSmvwaFEzzPS+Oi8DSisf5cHvsybmwLSgBJklMRnEx7iAff3OQHqgbGEiXG0X4fN19n4m99xYR4EeLIE8xw1MdTh697hCKJ/haKnB1XYHljylizb5BgpqGgV6OUUXjf3VrLK3IuD6AmfqqiErDNqVG53ZLRbAoxvbu8lVSYTiYEiZoeKqR4fauh+RPeogKmujLuCX6+OBzYS3I9X8dFcxmJQIRVZQWnQeZUvacPigih7BBmTfhe12N5KyrViWXgr5+K/ImuzElDIBX1ZOxE8nLTR4GabmqZg94VA0BWy+FtTTtpRnmy9ESnTVOfToDkhIMgSQZVVglJRr33l7RLR1J9P8rmCUufOGqbLVrYerW6PxL8Ko15CTGrXdaTV5zpTwrAQ/bFj6P4mJnycB34Tnhd5H7wwe98Y95ds+U4sni7M/kz1sZTyz16doK4uPNP3cp4CDibn8UI4fwo2JU/7fl3Y3Lo+YWgxlf3mKRY1D8o195a5u2l6RCIqh8GackffyLARxuzqggJAIfpC3IU7I83PmZcTpRKTIPpK9HgcieGLpcSL/W38Zrn6NBjYX8tEAYmNhPE5ZSuQPDZSiwyBE3EfFJh4e3yLyFTx12N/h3mBcKHxgT0bwrDiWi52L8DLPFg6G/KB7IKw3poZW7aUYwbMWYcYfBvmMu+pQHwIZycMefANIYTr4wpI/jFvwnjyC4JncJiLuGg6PqLQgieE7w3sRfNymiJAXirP/uz8PgVp4EEI4TTjMU0tEumWk//2vAAMAsBJiAw3OAAsAAAAASUVORK5CYII="

/***/ }),

/***/ "8b4B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.5977a7b.jpg";

/***/ }),

/***/ "8b4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('form-contactenosEN')],1)])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("LqK3"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Contact Us")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banda-azul"},[_c('div',{staticClass:"texto"},[_c('h1',[_vm._v("Work with Us")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:empleos@ciamega.com"}},[_vm._v("SEND US YOUR C.V.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8wsf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.ee19b67.jpg";

/***/ }),

/***/ "90vf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CabeceraEN__ = __webpack_require__("DPbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PieEN__ = __webpack_require__("LKlI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contact',
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_1__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_2__components_PieEN__["a" /* default */]
  }
});



__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.profile .box').toggleClass('open');
  });
});

/***/ }),

/***/ "98sY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "9ICL":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ "9NjF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relacionesInstitucionales_en_vue__ = __webpack_require__("lao+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2469d7d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relacionesInstitucionales_en_vue__ = __webpack_require__("5lMt");
function injectStyle (ssrContext) {
  __webpack_require__("MnXy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2469d7d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relacionesInstitucionales_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2469d7d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relacionesInstitucionales_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9jRN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('span',{attrs:{"id":"comercializacion"}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("+9VS"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("About Us")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cont-1300"},[_c('div',{staticClass:"left"},[_c('h2',[_vm._v("\n          Our History\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          This challenging undertaking dates to 1997, when the companies "),_c('strong',[_vm._v("YPF S.A.,\nPetrobras, and Dow Argentina")]),_vm._v(" conceived a project to fully exploit the potential of\nnatural gas."),_c('br'),_c('br'),_vm._v("\n\n          With the development of this project, the valuable components of natural gas became the building blocks of the petrochemical industry, boosting its growth and making a major contribution to Argentina’s economy.\n        ")])]),_vm._v(" "),_c('a',{staticClass:"right"},[_c('img',{attrs:{"src":__webpack_require__("IG1B"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cont-1300 left"},[_c('div',{staticClass:"right"},[_c('img',{attrs:{"src":__webpack_require__("TuIl"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"left"},[_c('h2',[_vm._v("\n         Our Company\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n         We are a leading Argentine company in the gas and petrochemical industries. Ever since 2001, we have been a key player in natural gas processing in the Neuquén Basin."),_c('br'),_vm._v("\n\n         We add value to natural gas through the separation and fractionation of natural gas into its individual components to recover ethane—the main raw-material? Feedstock used in the petrochemical industry—, "),_c('strong',[_vm._v("propane, butane and natural gasoline.")]),_c('br'),_vm._v("\n\n         We supply the domestic market with our products as well as several international markets in strict compliance with the highest world-class quality standards. Our shareholding structure is made up of YPF (38%), Petrobras (34%) , and Dow (28%).\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"instalaciones"},[_c('h1',[_vm._v("Our Facilities")]),_vm._v(" "),_c('div',{staticClass:"cont-1299"},[_c('div',{staticClass:"mod"},[_c('div',{staticClass:"derecha"},[_c('h3',[_vm._v("LOMA LA LATA SEPARATION PLANT - NEUQUÉN")]),_vm._v(" "),_c('p',[_vm._v("\n              Loma La Lata is located in the heart of the Vaca Muerta formation, the main unconventional hydrocarbon reservoir in Argentina."),_c('br'),_c('br'),_vm._v("\n\n              This Plant processes approximately 40 million standard cubic meters of natural gas per day\nextracting approximately the equivalent to 5 million cubic meters in liquid per day. “Dry gas” or\nmethane is then sent to YPF S.A. and fed into the main natural gas pipeline systems (NEUBA II,\nCENTER WEST AND PACIFIC). "),_c('br'),_c('br'),_vm._v("\n\n              Extracted liquids are then transported via a pipeline 12 inches in diameter.\n            ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=Oyc1XsNhQg8"}},[_vm._v("Play Video")])]),_vm._v(" "),_c('div',{staticClass:"zurda"},[_c('ul',{staticClass:"owl-carousel"},[_c('li',{staticClass:"slide slide1"},[_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=Oyc1XsNhQg8"}},[_c('img',{attrs:{"src":__webpack_require__("uR1W"),"alt":""}})])]),_vm._v(" "),_c('li',{staticClass:"slide slide2"},[_c('img',{attrs:{"src":__webpack_require__("n5hO"),"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"mod"},[_c('div',{staticClass:"derecha derechas"},[_c('h3',[_vm._v("TRATAYEN GAS PIPELINE")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Neuquén")])]),_vm._v(" "),_c('p',[_vm._v("\n             The construction of the Tratayen gas pipeline will substantially enhance our production and\nsupply structure. This major investment will give us access to part of the gas coming from the\nFortín de Piedra field and to future Vaca Muerta resources.\n            ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=BJQR1BmQS48&feature=youtu.be"}},[_vm._v("Play Video")])]),_vm._v(" "),_c('div',{staticClass:"zurda zurdas"},[_c('ul',{staticClass:"owl-carousel"},[_c('li',{staticClass:"slide slide1"},[_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=BJQR1BmQS48&feature=youtu.be"}},[_c('img',{attrs:{"src":__webpack_require__("d7h+"),"alt":""}})])]),_vm._v(" "),_c('li',{staticClass:"slide slide2"},[_c('img',{attrs:{"src":__webpack_require__("GFzQ"),"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"mod"},[_c('div',{staticClass:"derecha"},[_c('h3',[_vm._v("BAHÍA BLANCA’S FRACTIONATION PLANT ")]),_vm._v(" "),_c('p',[_vm._v("\n              This Plant is part of the largest Petrochemical Hub in the country: Buenos Aires. "),_c('br'),_c('br'),_vm._v("\n\n             \n              These fractionation facilities separate natural gas liquids to obtain ethane, propane, butane, and\nnatural gasoline. In addition to this, the Plant also has dedicated storage and shipping facilities\nfor propane, butane, and natural gasoline."),_c('br'),_c('br'),_vm._v("\n\n              One of its competitive advantages is having a pier in the access channel to the Port of\nBahía Blanca, the only deepwater port in Argentina. This allows product export in large vessels.\n            ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=k1anD59igqU"}},[_vm._v("Play Video")])]),_vm._v(" "),_c('div',{staticClass:"zurda"},[_c('ul',{staticClass:"owl-carousel"},[_c('li',{staticClass:"slide slide1"},[_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=k1anD59igqU"}},[_c('img',{staticClass:"tercer-btn",attrs:{"src":__webpack_require__("9wto"),"alt":""}})])]),_vm._v(" "),_c('li',{staticClass:"slide slide2"},[_c('img',{attrs:{"src":__webpack_require__("dO+U"),"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"mod"},[_c('div',{staticClass:"derecha derechas"},[_c('h3',[_vm._v("600KM-LONG PIPELINE")]),_vm._v(" "),_c('p',[_vm._v("\n            This is the only pipeline in Argentina to connect Vaca Muerta with the international deepwater\nport of Bahía Blanca. "),_c('br'),_c('br'),_vm._v("\n\n             A 12-inch pipeline connects both plants passing through 4 Argentine provinces: Neuquén, Río\nNegro, La Pampa, and Buenos Aires.\n            ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"25px"}},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/Folleto-A4-Mega-v2.pdf"}},[_vm._v(" Prevention and Safety"),_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=LrcJP42NSmI"}},[_vm._v("Play Video")])]),_vm._v(" "),_c('div',{staticClass:"zurda zurdas"},[_c('ul',{staticClass:"owl-carousel"},[_c('li',{staticClass:"slide slide1"},[_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=LrcJP42NSmI"}},[_c('img',{staticClass:"cuarto-btn",attrs:{"src":__webpack_require__("J9be"),"alt":""}})])]),_vm._v(" "),_c('li',{staticClass:"slide slide2"},[_c('img',{attrs:{"src":__webpack_require__("qJL8"),"alt":""}})])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"comercio"},[_c('h1',[_vm._v("Production and Commercial Process")]),_vm._v(" "),_c('div',{staticClass:"cont-1170"},[_c('img',{attrs:{"src":__webpack_require__("tYMN"),"alt":""}}),_vm._v(" "),_c('video',{attrs:{"controls":"","src":__webpack_require__("0eQu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9wto":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.c0e2071.jpg";

/***/ }),

/***/ "A/h3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A57j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__ = __webpack_require__("g4dN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel__ = __webpack_require__("YiUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CabeceraEN__ = __webpack_require__("DPbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PieEN__ = __webpack_require__("LKlI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.slider-principal > ul').owlCarousel({
      autoplay: true,
      items: 1,
      loop: true,
      slideSpeed: 1000,
      autoplaySpeed: 500,
      singleItem: true,
      dragBeforeAnimFinish: false,
      mouseDrag: true,
      touchDrag: true,
      nav: false
    });
  },
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_3__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_4__components_PieEN__["a" /* default */]
  }
});

/***/ }),

/***/ "AX/Z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/becas2021.92dec1f.png";

/***/ }),

/***/ "Aw/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__ = __webpack_require__("g4dN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel__ = __webpack_require__("YiUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pie__ = __webpack_require__("iPQG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'medioAmbiente',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.zurda > ul').owlCarousel({
      autoplay: false,
      items: 1,
      loop: true,
      slideSpeed: 1000,
      autoplaySpeed: 500,
      singleItem: true,
      dragBeforeAnimFinish: false,
      mouseDrag: true,
      touchDrag: true,
      nav: true,
      dots: false
    });
  },
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_3__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_4__components_Pie__["a" /* default */]
  }
});

/***/ }),

/***/ "AxVR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BSnh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/premio2022.a623556.jpg";

/***/ }),

/***/ "BesW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C2P4":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "CEDn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cabecera'
});


// Menú hamburguesa //
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.burger').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('is-active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.nav-principal').toggleClass('activo');
  });
});

/***/ }),

/***/ "CEc7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nuestras-plantas.9c65655.jpg";

/***/ }),

/***/ "COVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nuestrasPlantas'
});

/***/ }),

/***/ "CSdQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.a6971b9.png";

/***/ }),

/***/ "Cszk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Pie__ = __webpack_require__("iPQG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'info',
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_1__components_Pie__["a" /* default */]
  }
});



__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).toggleClass('active');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.profile .box').toggleClass('open');
  });
});

/***/ }),

/***/ "DPbz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CabeceraEN_vue__ = __webpack_require__("vPma");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15a6369d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CabeceraEN_vue__ = __webpack_require__("+82U");
function injectStyle (ssrContext) {
  __webpack_require__("NPcl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15a6369d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CabeceraEN_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15a6369d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CabeceraEN_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DQ1w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2c.9075465.png";

/***/ }),

/***/ "Df+U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/introMEGA.3cf8f75.mp4";

/***/ }),

/***/ "EFv3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Pie__ = __webpack_require__("iPQG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'relacionesInstitucionales',
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_1__components_Pie__["a" /* default */]
  }
});



/***/ }),

/***/ "EUJ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nuestraEmpresa',
  data: function data() {
    return {
      msg: 'Hola Juan esta es nuestra empresa'
    };
  }
});

/***/ }),

/***/ "EckT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ExI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Organizacion'
});

/***/ }),

/***/ "Eyqf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FAKZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.84db97a.jpg";

/***/ }),

/***/ "FpEW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.f403d87.jpg";

/***/ }),

/***/ "GB09":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.4d8de50.jpg";

/***/ }),

/***/ "GFzQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.a28e083.jpg";

/***/ }),

/***/ "GNe/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GRSW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/planta.3e6849c.jpg";

/***/ }),

/***/ "GgKY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Nuestras Plantas")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("La ubicación geográfica de las instalaciones es otra característica particular de nuestra compañía dado que el proceso se divide en dos instalaciones: una planta separadora y una planta fraccionadora, conectadas por un ducto de 600 km de longitud que atraviesa cuatro provincias.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("La Planta Separadora")]),_vm._v(" está ubicada en el corazón del yacimiento de gas natural argentino, "),_c('strong',[_vm._v("Loma La Lata")]),_vm._v(", provincia del Neuquén. Se abastece por una corriente de gas natural de aproximadamente 40 millones de metros cúbicos estándar por día para alimentar el proceso en el que se retienen líquidos por el equivalente de aproximadamente 5 millones de metros cúbicos por día, retornando el \"gas seco\" o metano a YPF S.A. que lo inyecta en los sistemas troncales de transporte de gas natural (NEUBA II, CENTRO OESTE Y PACIFICO). Los líquidos retenidos son transportados por un poliducto de 12 pulgadas de diámetro, a través de 600 kilómetros que separan Neuquén de Bahía Blanca, donde se ubica la Planta Fraccionadora.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("La Planta Fraccionadora")]),_vm._v(" se ubica dentro del Polo Petroquímico de "),_c('strong',[_vm._v("Bahía Blanca")]),_vm._v("; el más grande del país, aprovechando así la infraestructura de un complejo industrial integrado, un puerto de aguas profundas y la escasa distancia que separa a la planta de su consumidor de etano. En la planta se fraccionan los líquidos, obteniéndose etano, propano, butano y gasolina natural. Además, presenta instalaciones especialmente construidas para el almacenamiento y despacho de propano, butano y gasolina natural.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Compañía Mega S.A.")]),_vm._v(" cuenta con la ventaja competitiva de tener un extraordinario muelle ubicado sobre el canal de Acceso del Complejo Portuario de Bahía Blanca, único puerto de aguas profundas del país, que permite la exportación de productos en buques de gran porte.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("CEc7"),"alt":"Planta"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gksi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.ee19b67.jpg";

/***/ }),

/***/ "GqkE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H+TH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_proveedores_vue__ = __webpack_require__("k4Q7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97911fde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_proveedores_vue__ = __webpack_require__("PxaI");
function injectStyle (ssrContext) {
  __webpack_require__("GNe/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-97911fde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_proveedores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97911fde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_proveedores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H0lJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_en_vue__ = __webpack_require__("90vf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_468c8918_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_en_vue__ = __webpack_require__("wcyu");
function injectStyle (ssrContext) {
  __webpack_require__("rp8O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-468c8918"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_468c8918_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hr6n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.45bd214.jpg";

/***/ }),

/***/ "HzIW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IG1B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.1e54a9a.png";

/***/ }),

/***/ "IJo5":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "IKix":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("Ugd8"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Corporate Governance")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"caja"},[_c('h5',[_vm._v("Corporate Governance")]),_vm._v(" "),_c('p',[_vm._v("At MEGA we promote and encourage the adoption of best practices in corporate governance.\n          Welcome believe these practices are powerful tools to build economic security and legal certainty\n          for investors, the community, the Company and all Company shareholders and employees, adding transparency and integrity to our governance practices.\n        "),_c('br'),_c('br'),_vm._v("\n          At present, MEGA’s Corporate Governance practices are governed by the Company’s\n          Bylaws, Code of Ethics, Internal Policies, Corporations Law No. 19.550, Capital Market Law No. 26.831, CNV standards and other effective statutes and regulations.\n\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("MEGA S.A.'s Ethics Line is a tool designed to report Code of Ethics violations. This line is available 24/7 and is managed by a third-party firm, BDO, to guarantee confidentiality, anonymity, transparency.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("4jPn"),"alt":"Banner de las plantas de Mega Cia."}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h4',[_vm._v("Whistleblower Channels")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Telephone: 0800-34-LINEA (54632)")]),_vm._v(" "),_c('li',[_vm._v("Webpage: "),_c('a',{attrs:{"href":"http://www.bdolineaetica.com/ciamega","target":"_blank"}},[_vm._v("www.bdolineaetica.com/ciamega")])]),_vm._v(" "),_c('li',[_vm._v("Email: "),_c('a',{attrs:{"href":"mailto:ciamega@bdolineaetica.com"}},[_vm._v("ciamega@bdolineaetica.com")])]),_vm._v(" "),_c('li',[_vm._v("Mailing Address: Rondeau 2664 PB, C1262ABH CABA")]),_vm._v(" "),_c('li',[_vm._v("Personal Interviews: Maipú 942 PB, C1006ACN CABA")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descargas"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('a',{attrs:{"href":"static/pdf/manual-del-anuciante-mega.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("UIPr"),"alt":""}}),_c('span',[_vm._v("DOWNLOAD MANUAL")])]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/Mega_ManualDeEtica_Mayo2021 (1).pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("UIPr"),"alt":""}}),_c('span',[_vm._v("DOWNLOAD CODE OF ETHICS")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Icca":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.5318e9f.png";

/***/ }),

/***/ "IyOV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ariba_en_vue__ = __webpack_require__("WGgP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb37bc66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ariba_en_vue__ = __webpack_require__("07yY");
function injectStyle (ssrContext) {
  __webpack_require__("lORO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb37bc66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ariba_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb37bc66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ariba_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Iz3u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.5e7c719.png";

/***/ }),

/***/ "J/5I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sistemaDeGestion_en_vue__ = __webpack_require__("a0Mj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34beadd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sistemaDeGestion_en_vue__ = __webpack_require__("TRbM");
function injectStyle (ssrContext) {
  __webpack_require__("UwE+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34beadd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sistemaDeGestion_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34beadd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sistemaDeGestion_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J9be":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.1f131e0.jpg";

/***/ }),

/***/ "JE62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gobierno_vue__ = __webpack_require__("RwWi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bc3ddb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gobierno_vue__ = __webpack_require__("2mb8");
function injectStyle (ssrContext) {
  __webpack_require__("QkJJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41bc3ddb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gobierno_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bc3ddb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gobierno_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JPVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_contactenos_en_vue__ = __webpack_require__("lyqC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e40dc74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_contactenos_en_vue__ = __webpack_require__("pbD8");
function injectStyle (ssrContext) {
  __webpack_require__("sDsX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e40dc74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_contactenos_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e40dc74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_contactenos_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KMsP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/linea-etica.a90051c.jpg";

/***/ }),

/***/ "KR7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestraEmpresa_vue__ = __webpack_require__("gkyY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f6cd601_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestraEmpresa_vue__ = __webpack_require__("u8GJ");
function injectStyle (ssrContext) {
  __webpack_require__("clah")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f6cd601"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestraEmpresa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f6cd601_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestraEmpresa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KWvv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("YuRK"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Financial Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"caja"},[_c('h5',[_vm._v("Annual Financial Statements")]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box"},[_c('p',[_vm._v("Financial Statement")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2022.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2022")])])])]),_vm._v(" "),_c('p',[_vm._v("Financial Statement")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2021.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2021")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',[_vm._v("Financial Statement")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2020.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2020")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',[_vm._v("Financial Statement")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2019.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2019")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',[_vm._v("Financial Statement")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2018.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2018")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',[_vm._v("Financial Statement")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2017.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2017")])])])])]),_vm._v(" "),_c('h5',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Intermediate Financial Statements")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Intermediate Financial Statements as of September 30, 2021"),_c('a',{attrs:{"target":"_blank","href":"static/pdf/Cia Mega - EEFF 30 de septiembre 2021 (VF).pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Intermediate Financial Statements as of June 30, 2021 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/Cia Mega - EEFF 30 de junio 2021 (VF).pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Intermediate Financial Statements as of March 31, 2021 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF 31 de marzo 2021.pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Intermediate Financial Statements as of September 30, 2020 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF-30-sept-2020.pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Intermediate Financial Statements as of June 30, 2020 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF-30-junio-2020.pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Intermediate Financial Statements as of March 31, 2020 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF 31 de marzo de 2020 (COMPLETO).pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('h5',{staticStyle:{"margin-top":"35px"}},[_vm._v("Reports")]),_vm._v(" "),_c('p',[_vm._v("Report on the Global Corporate Bond Issuance Program for negotiable corporate bonds no\nconvertible into shares for a nominal value of up to USD 500,000 - June 24, 2020 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/Prospecto - Compañia Mega SA.pdf"}},[_c('i',{staticClass:"icon-file-pdf"})]),_c('br'),_c('br'),_vm._v("\n          Summary Report on the Global Corporate Bond Issuance Program for negotiable corporate bonds\nno convertible into shares for a nominal value of up to USD 500,000 - June 24, 2020 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/Prospecto Resumido - Compañia Mega SA.pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KZkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Nuestra Empresa")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-3"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("LCV4"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-12 col-md-5"},[_c('p',[_c('strong',[_vm._v("Compañía Mega")]),_vm._v(" opera desde principios del año 2001 y tiene como visión y misión:"),_c('br'),_vm._v("\n            Ser el protagonista esencial en el procesamiento de gas de la cuenca neuquina y en el desarrollo de infraestructura energética en la región, impulsando el crecimiento de la producción de gas y potenciando a la industria petroquímica.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Contribuir al desarrollo energético del país y al desarrollo del sector petroquímico.")])]),_vm._v(" "),_c('p',[_vm._v("El eje principal de su negocio es agregar valor al gas natural a través de la separación y fraccionamiento de sus componentes ricos, a fin de recuperar etano que constituye la principal materia prima de la industria petroquímica argentina y exportar los componentes líquidos hacia otros mercados.")])])])])]),_vm._v(" "),_c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h2',[_vm._v("Productos")]),_vm._v(" "),_c('p',[_vm._v("La separación de los componentes líquidos del gas natural y su fraccionamiento permite obtener como productos principales etano, propano, butano y gasolina natural. El etano constituye la materia prima básica del complejo Petroquímico de Bahía Blanca, a partir del cual se obtiene etileno para elaboración de polietilenos y PVC.")]),_vm._v(" "),_c('p',[_vm._v("La producción de propano, butano y gasolina natural se despachan vía marítima a Petrobras: el propano y el butano tienen como destino el abastecimiento de los centros de consumo, mientras que la gasolina natural se utiliza mayoritariamente como materia prima en la industria petroquímica para la producción de etileno, propileno y butadieno.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("4nLF"),"alt":"Banner de las plantas de Mega Cia."}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kuwp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.84db97a.jpg";

/***/ }),

/***/ "L+Nk":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBBRUNFRTc1RUIzMTExRUJCODFEOEQ5QTY5MjQ1NDE1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBBRUNFRTc2RUIzMTExRUJCODFEOEQ5QTY5MjQ1NDE1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEFFQ0VFNzNFQjMxMTFFQkI4MUQ4RDlBNjkyNDU0MTUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEFFQ0VFNzRFQjMxMTFFQkI4MUQ4RDlBNjkyNDU0MTUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7Mif5iAAABFElEQVR42mL8//8/Awww+s0XB1I5QOwBxMpQ4ftAvBOIJ//flPgcrhamEagpHEjNBmJeBuzgKxCnAzUvhWsEagoAstczEAfCgJpXMzL4zhMCct6ADEGSbANiSyB2xKFZnAlIlKJpAoFDQFOdgPRlHBorQRoDsEjsADo/EqhZD8i+iEXeB6RRHoepy4Cac4CaDYDs02hyUkwEAoIVSv9DE2cEaXyEQ1M80LZ+oK2ngGxzNLlnII2bsPkBqGkRUNNZINsUi/w2UHSIABmv0SRagNgCiF1wuEYSlgBCgZxVRCaAaKBrloEDB5QSgFQMEH/Ho+EXECeCNKGkVWh6lQFSeUDsCo0mUMJ4CMR7oIn8IUwtQIABANQtWQtASYCZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "L27D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.470ce4b.jpg";

/***/ }),

/***/ "L5JE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4c.c2c689b.png";

/***/ }),

/***/ "L9DZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",attrs:{"id":"footer"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row "},[_c('div',[_c('div',{staticClass:"datos"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("U9Kg"),"alt":"Mega Compañía - Logo"}}),_vm._v(" "),_c('div',{staticClass:"rrss"},[_c('a',{attrs:{"target":"_blank","href":"https://ar.linkedin.com/company/ciamega"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("kzQl"),"alt":"Mega Compañía - Logo"}})]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/channel/UCJIz0KFkNtsea_iY-H2b2cQ"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("bDnV"),"alt":"Mega Compañía - Logo"}})])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"datos"},[_c('h4',[_vm._v("BUENOS AIRES")]),_vm._v(" "),_c('p',[_vm._v("San Martín 344, 27th floor, (C1004AAH)")]),_vm._v(" "),_c('p',[_vm._v("CABA")]),_vm._v(" "),_c('p',[_vm._v("Tel: "),_c('a',{attrs:{"href":"tel:+541128210300"}},[_vm._v("(54 11) 2821-0300")])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"datos"},[_c('h4',[_vm._v("NEUQUEN PLANT")]),_vm._v(" "),_c('p',[_vm._v("Ruta Provincial 51, km 85")]),_vm._v(" "),_c('p',[_vm._v("(Q8300XAD) Loma La Lata")]),_vm._v(" "),_c('p',[_vm._v("Province of Neuquén")]),_vm._v(" "),_c('p',[_vm._v("Tel: "),_c('a',{attrs:{"href":"tel:+542994904400"}},[_vm._v("(54 299) 490-4400")])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"datos"},[_c('h4',[_vm._v("BAHIA BLANCA PLANT")]),_vm._v(" "),_c('p',[_vm._v("Av. del Desarrollo Presidente Frondizi s/n")]),_vm._v(" "),_c('p',[_vm._v("(B8000XAU) Puerto Galván")]),_vm._v(" "),_c('p',[_vm._v("Province of Buenos Aires")]),_vm._v(" "),_c('p',[_vm._v("Tel: "),_c('a',{attrs:{"href":"te:+542914037650"}},[_vm._v("(54 291) 403-7650")])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"datos"},[_c('h4',[_vm._v("Poliduct Emergency Line")]),_vm._v(" "),_c('p',[_vm._v("To report any irregularity or make a query about our pipeline, call our toll-free line 24 hours a day, 365 days a year:  "),_c('br'),_c('strong',[_c('a',{attrs:{"href":"te:+5408009998050"}},[_vm._v("0-800-999-8050")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row disp"},[_c('p',{staticClass:"pata"},[_vm._v("2021© All rights reserved")]),_vm._v(" "),_c('a',{staticClass:"patas",attrs:{"href":"https://synapsis.com.ar/"}},[_c('img',{attrs:{"src":__webpack_require__("SDkT"),"alt":""}}),_vm._v("Synapsis")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LCV4":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhjACCAPf/APH092uXY5K2itJ+m+zE0Wh+xNfl1qi21a6NqHCHqvP2+LvUu42Rr9qSqu7y+uru8leFSMNaduq7ytWFof7//96asrPOsW9xkdPc8Zq8k82yut3i6au84zpSp3OHx8HN6sHZxPPZ47M8WOKlu0Viho2yhdzg5bTD5rzK6aLCnOu/zsnU7r1NaMllhZyw3WaSW76kueayxOvy6pepyHQGC4OWzaO14OWuwdSCnk58O5Sq27DMrdeJpEJarVpyvK97me/M11Nqt2F4wK7KquCht0tjsvb4+ooTJdrf5N/k65mt3ICoduXu44t4l4GqeOHo9t3k9NPY2MXS7eSqvvXg6Onu+O7I1vj5++m3yOTq9+/y9ruBjb3Wv7RCXmaLRV+DOtiMpl95nOzw9LXQtNXb6tjg8ltrjYmvgKrIpmKOVYuuhcDYwnifaXGVVsvdysHWvYINGKjGo7jD3qXEoMeEn6a44c3X7tmOqNazwPHV36QnN8h5l4atfrnG5LjSuLyWr/T48+Pn7JWr3Pn6/Oe0xe7w9MvU5+jV2Zes3MXZwqa7oMPax7/K49fc3+ft9+Xq8MPXwPns8PDP2sxxjpJDR8Xcyvv8/fvz9cPPxcjbxdOWrczW0dDa8OO5yJeq0ODj59JyfIWse5/Amdnh816KTuft+N/m9d6UppGj0cCgtJyt0N3p3JWEoJ61mNyUrejr7uezvrG+3YecvJa5j8bSytXf8rnI6JKm2Pn7+Y+jyYuf1Nvk9JWthcnTytGftuzx+YKlfM3gze/y9ejl6+vw91Bqjn6lbu707Zy+lv35+oOreu/N2Oi1yK/A5ePo8dzj8oywftfe6N2/y9vk892YsNLi0YKsfI2neVOAQLHDrZ+z386Uqebf5eTP2sjcx7bG55On2e7x9d+dtP78/e3H0evv+Nzi9Pf694CdZ9/o9em6x+7w8pewkPz3+MuOp4GncdN/nfD18OHr4KCxy+fv5sbQ5dLcx7rKvOjs8ZoeL6ViZeHD0OPJ1d7k8c7X5////yH5BAEAAP8ALAAAAACMAIIAAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKjAgIkklIApaoXLkyw8iXMBfikiFD1KwSLHOydCIgpk+fuN68yaCzaE4noWT8XPqR3qpZApw4MUpVpRNj9phqzUhvDJ9QoZRJrUrVSZshW9NKjOcmQ4kzZ74qEzuW7FEv1/AZvESlr9+/apdSgOT2LVw+X8PWtcvSS5tPBvPw4DFhAg7LOHDAm3LjRox248YF9kiByRxkAkqoNhxXrljGOb182WSpoOTJlTFrhgdvwIAJk1WEED0aI4UFs6AKSL0ablywcxfbdSL7nhHbYMBQrpy5O2/f4AeI/5tCKBnx4hABGUiRIbly5qoPf7VGF/ZV2b2EFQxxR/t27pl9F154EzSQB3oPuYEGMshk0F5yy8HnHGLQSTUVWda08YUXUbxi2x39+Zdbd7sNOKA4I0SCYEIyJCKKKAw6+GCEqxmGmGvSGZXhF2008gkFAyVDDYjZaZebbrwJaKJv8NxAxYoEWSLPHHOkIMocY4xhgU0QLlejfDjatSM6SJgwSJCuNNAAkSICGGBvS4YHDxEqrniOH3FQmUIKflDgZ1Du0dhcaxVeSNWOvHxiggJBUpMmm0a6uRuccYYXA4J3ohFHnlX2CaMB8bSHzBAZCDDETWhkcIZNOOa40n1ftP9igglXBFmBK2muGeJ/mCVJaaW+VXBgYPIsMAQamubJJwUwjkFBBjucQ8E5Q9ADCTIUGHAGtRRGZ+hRbHzxRTaz1ibQOOLgquaaYNyBm6RKAsskAZekVc0OOwxxrKZULsCsKM5msMpTAydirZ87UEBoWPXp5ES4X9xjwifnWVGBo7myW+R/3sUrryt1LlWNBRbkq2+yc/hrpbPIMJHJLInIEwcF9HhDs7aHhUKfhQ6H6wUtJgRCEBYXY5xrkZGOWKK8AxKylAFalmwyspv6u4AfMjCBjAEyWCBDNbNIO4cBFLwxYWLROWwMj1GY4OFAKlQgNzUYqxlim7otzbRvnfj/BHWWJON7sqb++snEDsjEwURpKcxSTTwC+OsWNK21epSGbZS5DkEqiDN33ezuOmKvHsvLDEwG+KE64FKfvKmye8LY4IPvfZkzw9JR9wU6s+onUDISECGO50Xnyua7ecODw97hYRHyRwYscPXqgZu876ZVxh4j7YLGt3Dar8rGy6yMCkQFEegLPzeuGd+93WUBasa8b3eEtAoX0qvuB+utU81p7LJzUJfgw5puNWwJupPVJ65jvhGMAH3DW5+6NIY80vXmV8DCARY+cj8u4G96+4ua4K73PyvBSEYDlNDtFHMh3ZHrE+b6BxUcmD71Fc947pOU3va2wY1QYBVr8KAH//PnhgVErXUk1JOVtheo5SAjBd6jEO6kYgzZAO1HA6HCFBz4QOERD3QaSxqJdsi002kEECBYQxCHuIBq/DCEgRscv7L3IibOQmYCgIQ8BvUc3O3IC5sIGkG0yMUuRvBi7NPVrjj2JgzKSx0ZwUUwQJDGNUpvcXcaAxfS+IZ8QWIMbxhCnoxlpR2gYQxxaA8FhkAj9qQyLiWYgwDEsqM2tO1t/xgHM6awRS5C8HMTpCDyOubISoGhXhaxxCQpqcY1ckFKFPCGH8hGgXjsQAaAOEbZhqBNCmQiBUzAhZ8skAmExawE8pAWBeIgAHVaQBljaoQJNneuGHSGlzSE4BcTGf9GMTZyfg04z0RkQMmCNpMLblxEPFYxTUD4gWTRtEDZqgGIIQQDF+A0wBzi4Y05UCARyIiZAORRDQHEw2wl4EMiVqEMPmjoGoryXS4Jcc9e5jOCdAtmA7LDAzAciZjzG9ZEjlHQoqqRC/SwxCqOcSeuAe6jCYOEG/1EAXC6QRRM8EYGKLADmMljpJBA5xtE0c1VhGIJsmGHohiYSyzEABY34KVNfynBdbmPkW9iHg6eJJFsFdWgarRENrXpDadqCRDxWFwiggGIRCRiDHOgx1Wziq1MhPSr8girPIRyjrGtgg9r+4IiZnWmgajDnjUtJF0R2T6evmuMxYzTDQTqEDT//pWZazCAJYQoA3msQgYhXIAByJaIIayCArjoKD2CYdWtUYCcmNXsULTplDOE9oUxDAEWmIHa1N50n+3LYfIuuLfnOaQatzWqMz+4ujEUdnF+GBz2AGjH2vHxDO/YECaCdh5JMIMQeEhFKv4wAnz60oZGs2t26ECH9wGVaSOISDwWkV7AOlN6IAyGDOiRiamhjI4B5J6X+LiEDd2SIHmQADNSQYIWFyMVcfXlHy5APNYq+AJNwGte5TUBvjbErxUGrBA/OD3WjdB/SqwjCrtkuzOEK3MmeACKJYAFFhMiBk1oQlx9QeAR/IEEwvvDNhDgDlyRGUQ4/kGD6aDmH2Tm/wc/+M4efrCHJU2BtgmxbZCFLMT8tbd68i1hiEVcI2iUQDa8m+dAxiEJCUgABiT4b5ZvgIAWX8AXF2gxETJNgiZowgwtbkIDOE0CNruYDpy+ADya0GIS1NlEeEYIevesXkv6eX/egITULAAJU8ZhBwvY07Hq2z3VyOYaswLAQCKhAhU8utUvvkExWDECM7Ci0n/Y9AXkxgozbIMVxRj1BXhghib8gAQ/qAwdcHBueFzgApXCgSQaMmFa//WofZ5ePPy0Cgu4QZy4SIQFAEHSFNBjrMQesbFjRb5lN1sFkIYBjK/cahKw4ssOvAArhseKC7ii0qNuwh3STAJ1k5rd7/9G95IivBAg25vPbFyAG47jRq8xYQhMkMEb6IHUBQDChLObkcIPPa6JlfYfkSAAASBOAgmoAwvbtfYfEDCFLxNY4+gDNwKaYAZX4Ngd5T73ZM6dZRKwG87lXlIDzGsQCrz8tgdlo/4MgAsLyCMeiThG9ABRDXnI45tAn10KSwAN2ewXhstWOtMdTeUVg/oCGSfBCLAuPFabAQHUuACozeCOcxsp06DGAatJcIFXm0ioCKHH2+GOb/bOfGQ285OxMlENP+BiDPSoRh0Fn0KIBVJoiVd8sx0NdUL8F7VbnCv65MZaHG5Maf80UQgWMuvV15qN3sDFKrJED3rsgAk3P9b/KqphrWP4YfcC7NIsfHZigVBAEkoXvrOdzoz/XrmmyldfTlvrWujLb0kEACQJYQDWx3pCtAbnEA/B4Aa4Fw+ZkFj5YgG4sAP0sAAVGHjpBxXrtzvyJGXuBwRWEH8PN39UhgWEcH/e1UVEwHwJFkbDFH3hgQOxJhDHQGEFqF5CFAxURQF+kAj7pnP5Ug2rgAZukE1xQF9LlhzhAlOK5n7LYAXkEH9LN3xOZ4JXhnw2pYKes38KxlM/5R0mwgMKQVQ3eG+td2tG5mHYA2JBByHioyjl8w/vZwV0KIVTyHjb9V838Ae+EFdbxGXoM2Zy4w5l5nx4QyLxggOoVxDyUIYG/xhz+pOGScSGvAcN4jJatEIQkkCHdSiCVNh4GgBqFidXlzcCn4ZjFXABCMBPdwV9HgMLCeGIrHdhfpYlIqQvx7KG9BV0llh0iCcQkbAMIMiJISh8eIgFW4cHrEACnYEAxeBAMzZjCGAGN2Q34jVe4CEOM2iDsmhh+RaJIqSGgiY7yCAKJaBfExNDVAAE7EiMUSh/jvZ0hKAB3dYZ1gaN1vZurFBX64I0/qckLbCIA8GN3VhJZwhCkpiLyMIv5PgOAeAEG/J7AihD7FiRxOiJwwd1DEACCBADzjgCrOALI4AAF1cMM9YEzWeNz6dDvRGQCEGQBRl3RNZegLMD1cNOy/+hDKSwk6QAATkgLlCGSxRZke3YicYYj1jAAMVACOX2ZVTnQE3QcdOIADamKxvjYGDYAtN3EDAZkwc5ZFKzA9BgDGTJBj6ZA9iQA2q5luKCDorigXK4jkQ5jEY5hSrAAGbwB+BGCBV3AX9YDJiGAKooQYb4gpkxAC0ABi9ZkH8Fk4vgB7GTAu/wApRJCmt5mZipltjwBchmAjJ1CXNpkXQYhe/YbJ1geQhwgjEQAyTwB7zECk0wkmZgBpoATIboU7xymC0wCYvZjZXwm5WwCAvgQWIJDdDwDmkAAcp5lpqZmc75k+yQbAMBmqFZlKOJkceomp3hhwd2SC14PF8ID7v/2ZsvtwjmuQjAWQk7sClokALGEADwSQrYsJzYUJ/2aZ/PmZmiNTFsdQmSUJ2iaYcPR3z1d4X4l082ZGNHc4g4sAfjyZV7hp6/CQIYxgVQpBrGkAYaqqHL2aH0eZ/4mZ9sKTG/+A/tEAIhYAUA6o6eyHiNp53ciaDemUggski5MQm7OZEEYYPnaZ7AuQZxgCzuyQZEygYbqqE8maQeqpwgWp8ieplfcHgTKQkiMAByuaJQKIJLh4f/xV1YqFoJeisThDTvgqOTcHQE4Qa/SWSiQCNsAJ8BQJkvoKFzeqRpkKQ9uaQQ0KRp+aQ88nsEcQmUAAegcKVzqaKc+I52iZQm/7iaKZg+M8p/PAUGZhpDBCFK7ESWxsAGcvoC8NmpoGqnd8qTerqnTZqfacAO7HAPjVAmQvkP+kADhGqooXmRS3eHxHeCKChXB5agrHg3OGCmaDoQbwqnxnqsnwqqdbqheJqnHsqnOZAGcnoPmFCtUYAE2IqtUVYQW0ADsgoKkfCftTqMirqoJWh/XyqjxOMKjtKFYICYu6lsBoGs9AqnyiqqeFqqpsoGrdCvrZCtABuw2ipT7ncE3goHLAALIYCl1wmPxGeFjhqjWkiY1ngH4rmbWnAQb1Cv9Kqsy8qs+UoKRcoOm1Cy8mQCApuy2WoCbPU7cOCt3qoH6rCwtWqrDv8LdceXrjfFgsEEIg6KsQfhBhyLrB77sUnaCoqQtBIzK0zLtCr7tLTiJ0FisDBLA3qABTRbs3WJq1Smq9vJqztLsWvSAmQ7CRlrEAZQrENrr6AaAMDwtsBAC1EwtxuwAU17t037tNgaDXwbDWVQBlBgCk/wC+6XClUbs1hbncRYjDe7XSgosYbEs7kyAWQLtAfRCmuLrMCQDZxLC3X7uaBrt3g7ugFLBobgD3aQupyAARhQC2UwCoH7BA7wD4MQBZRwuFZLCFmrteX6iVZIU1+bf+DlCj9ruQYhAByrBsqrBlHQCM4butALuqPbtP5wutWLAijwAdorBSuwAnawuq3/+7q7AAXpILsUEAiNcLuHK7O7S5Q2e4fOVnwGKrGQyoLU0AA4WrZnaxDVYKyreg8AnAQCPMADHL3Ry7R9Gw2M0AcM3AzNcAIn8A22gL3by72py7q1UAujsAuCmwVZAACvgAS2i7t6oLAqqrgNa64vGrH0G6Y8ULktcAP7WxDncA/ZSsA4TMAGHLomUA8+3AfaYAM2UAdEzAFG/MARPMHZ+wHc672csLquOwrm0MEe7AjYmr4krLAMq6gD+rCqqbOGRDwXS7bdMMMFoQA5nMY6/Lkm0LfNQMR1YANKMMcuoA1BPMR1cMRILMEUzMQWbAcYLL6x68Gl4AzYOsLra8JY/0oOvTt/T4euwauu1ADDLVDGCWEEgaDGaazAjNDJ2iAIoKwDOgDKgjDHSlDHdozHRswBDpzEfSwFfwy+GgwFUPAET1DFhXzI6lu1+aDFKEwOWWqXJJiHEWtgKjgCY9wCmhAOZlwQ+KDGfWsIcKwNolzN1izKgoAIdIzKQgzHRwzBfLzETay6GDwKsEvFpVAF5WDIIjyoh5sPN5CiKAyFXOy7EAvG1JC/ZLvMzUwQrzDA9dDJjHAC11zQBj3KiKDNLrDQd+zNrAzOtjDBFey931vO5jDIWeAI6rzO2qoBVAuzvUwF4nqonIiRVOi4xZyFOEDJ0sDMCoHGG8ABBz3TBv+dzQqNykHs0Hsc0UvMxBQNxRp80VSc0eXwC7/wCBtQJhrwsjALB/kQAXkw0u6bqC06f8WX0gVGBPpMtuHg0gkxDlpgCXZA02RtzdlMx3ac00XMyg8swRLtxz9dzuM71Olc1EYdCEpNtXDwsnAQASEg1RYJgoyMnY1Xf1hdvPssBl6dEECCAWX92Gd9ytys00jM0xNNzq07CtMQuOlQxY5QDnbtAL+QBHm916Z9BFAN2HRZl138ojRlTzHgCpTcAvzQ1S2bEJzw2GUd2TiNx3n80En81j7txOV8zqbgwVlQ17/gAMw92qVt2nCA2n/NsMWoAlzbeKtJCBUw23vADV3/bakJ8QxKoNs0zduTvdatfAKWvb3dW9GZfc63XMXqbNTMLdqkbQIeDd3R7deqTZeDLczzV6CEgAUDEAGUPALMHA7gnRDNQN4HDco3rQ117Nt6DMHrPdzu7bqbbQqdLd+hXd+/EAizkt/QLd39Ta6NHOBYIAETEAEuDsOKrQUKoKMKIdMOXtPaLNmprMpsDdE9Pc6ybM6cjdwaPd/13dxJYAIbQOKnzQJRPc+Mq8JY0OIu/uItgAeFoAUy/hCOfePXDOERrta/nd7hfNlPHL4bzOHxrdGgvdxHLtoibgJ4cAT6fQQsMN1Qjp0EMAVV3ueTwA1argW1whAUYAQPAA5e/27WkX3KO77WwH3hQA7F4svhRF4FRv7m9q3kTL7Xdi4J/f2+zUYAhNACfV7lRBDoWkDjCXEF+DDKiV7Ni87NFN7jZY7hZ67BsEu+lV4F9I3pcD7i+VDnd/7pJa14VoAFLcACLFDqEfAAgR6HDDEIYlAHiP7qCJ3jsu7oO/3jsfzeU1y+8s3rbu7rDhDnjbAF0X0E6m7nKJrnBGAFKpDsyr7sL74PzKzlw6oQg6AF9YAKiGDtNr3NqazTEKzer9ztGDDpVFzkvU7uIT4rgbAF677uInAK7WudVrAM8d4F8z7vEYADqA4AC54Q+y4HHnALgpDoYK4ENYAKdYwKMJ8Luf/gCazMAZ7gCaqgCrFQwQdwAPUg6WWwC4xgCGtu6UVN7kfuDEmwARE/8equBxaPwpKw8Rzf8SwwCcOA6tBO6ArwDB7gAf+u8gmtBAlQDC5wCyQgC2HQagnQDDNQcbKgvSiw9iRQDAdQzpxAAmEQ38l96UjP3MSw9E3v9FB/8cvQaBHQBYqv+B3fCaiuBTOYEAqgBTUgBLcQ9g6e8meNCiTgAWVvA2GQAHXgCSSgCm9f67JgBto7A+D7uvPQYv6Ay37/9w5QDnU7+BNf+EQpCSGAA4v/+1WvCTGu5bfdEEagBbogBB4w3ok+9mQfBsUgC6Av+qRv+iSA86qwxLJQDKr/cAAZPgoJkABhMAPIbfTjTvsOQAy3L/GEH/VAkAchMABdIAIiAPyKvw1dfe8iLxFgDRCjCgjRhUjHQYQJFSIUJAiREiU6ioXRZiMMCYwJms3AiBHFhw8oEhQjUYwRBgy1OJGYJytMFphVqpT79cvBTZw5dZZLsiHQliNBheo5RSXPjUkilIro0tTpNjHhwmmhquDfVaxZtWaloKWfhwIFwAlaWDZhw4dKXIRJUJFtLk8cNpI48c3WR5BSVnwIkwtlrXkkZMki4Q9mqZk2dS7WSaznT6FDeUxhsdSy0y7cpE6lamnr560UAGjhMLCGQbNlGzqEuLatxQR1OMjleMLW/12QB2QdmFdsxoEZtRKwHTnD3wzENB0oZsyYp0+gkY/ks1y9C1NpUaVSNQLae1YjWuSEFVKDbOqFaFuzdRt79lzbuD/MuFhMFqdcCeyQYATFFH05SHAkMeaaY8wx6KQ7Qo/rqlOqi+y0mwoACr6z0AgxtKiBvFtQQ48h1tRyQZuK6jDxvWbqsgsvKfRawQ47UqqljFGggCKdJ2AasBzlDDTwuSSiEyqfBq2LUDstABjEQgsHeUCMesjzoKEPz0rLhRErsuFEuVKs6y4WV3gxxpRo9O+JHLPYsUcfmwNyCz2GLHKpCI7cTovumPyOAjHwwWfDgaY8r8oQsSTRhi1l6//yhC/x+sBFOzjhpMwaTUHzsJloKrDNxnpKgpsugqKuOneeFONUzhSoUM/v+hSDkbAC1WHQ1NQT8dBEUWR0RZAeFRPGv2qpFEcdS9GUUx/LCSSJJIYJdcEiSzUVSQU8Y/U7I/B5AABAA6USPbQeMvRQLnPRZtdmVPkGJDkOeJGRk1IaZZcb01yzJmR9dIRZUKFVio4Hpo1Ki2qvtdCSB/ARgxOwpJwV3BBvRdREF0gS7IRcSPItFjMSkMWOBOb5q8Z6D3NE003zzWkQMZgdhhIGIzgk4Gk5s9Zg77pKWIsDYg10LHARETfLEuuQJTbCTmDLluHmCeOAp82YtBZh6SX/Vk2Z2FQ5JyMAcCEWZgPhhoUIuKH5VFTxxJlJI2h+QBefhSgvItUaao3oRGVzYaQThlMljN3MODqBGaamkV5LddwR361vopARH3rooB5mkwhkmIDRHhjPVdf2juWzuyXPPA/PKnTEiU8kTJYTPOnogPlkiaWYWDzGYJR5z4Qpi+QY39qSJ3QJogPi/Qnk+EfORnUqIzr33DsFaNaiD5/JK0AXuq28EvW8Z5OlmL4TYDqBR6XwOOQwYqnav3SKTaxxI4z4wAPi6z/g+EAe0Zxa558HzZJTBUwLsajeQAowpdLZrTUkKtpI8gM+v7EFJIwoxgcScIAEqC93iVNT71LW/xxLKGB+kqsf8YKAP/2hTSpK6p//QKOAAD5ACycoYKCwdx5bjStR2khASVj3NxI87VFHs8MMzBAGQwhrGrrD1LHaZIQroMADJCwh8YQAgEfk70nbAcDNXHiwcGgOAAQsoNw8oAuH5DBL3VtUfFgEqUlhoAxlWCIHHeHB5vyieQ6QIhWrSDwfdO0RyeOiF79oIQVs5lQAGE8NzagLF2xvjSZSVDO8dBtHwfEvZUBc+5roO5woQFUrsIEQ/njKDhzgHwp4RYYItqRDsooCiZTKIsnoSCGc8RYj0iEldeXGXrXoRZKiFPt2t7gCDYICpiiDB4qASlTG4iowVFssDTYIqv9QJSoA6APcajgQudWgBmtkoyUZhclg/iqOwjKHMT/pgPhdwRKxUMLwoHlKH6gSK1C05tquMBqqhFEL4UDFN8kjBB8cEByIkA2XzNmoMA3TcJWyYxWuQIFycGIUNRCCH+9ZQiFswJD99FzXADrQgdahYWUEJ0LLUwNwNEMuu7oNmPKil0hNbRSXykIV8PULiNDvo9DsgRz8NFKS4iyEAGDqaIQRDgCQQXSxkltV5eYDHwghLB4gVx3KNyad7sJSUHDUB8Dpg/p5dKgdKEIN/KGtB1glqS60hBFE2dRsKuCWcbNqVbH61yD8VZy6IGxhDauLGvSgCD1gLGOJ19jGrpX/eLmIBlwDJoy5frGuolQAXpPUD1SsVKt9vepfTRuEIBRBtatVLWQVu1rXunatbX2r8goBgMxq1q6cZWpeyeAC65G2tKbFKmqNa1zWJje2sv0oKshg2VMVQhhJGkdu6Ro/zt41mwBwRkFb2lfiAva4yE0ua5cbWVSW57nKC8d0k6Qk614Xu7w9qQI44QLhhre44z1ueWF7XrV2wAOxsOyTCtHe9wJAAUZAanyvNY5BxG+3vN2uM+qhCw9YVb/8Ja9/AexY4hWhAAeorNvEcODpNlWUg2iwg695BQlP2LNUeUQfPDHc03I4tf5tLYCLcIADGMJPtkUwUzlrBFi6+JCW/4hwjOl7UmEAwE8uQCxxdczjxbrWA1tmxAaSMOTMRbfIChYlFFuoZP9RYBAwdnJ2e6sFYUx3uvBixAEQGl4d7zgIB4hFLIwK5jAvz71GLrM80TxXJl+BzfN9cjafuhmoNlXSkwaA2yy9PxVKZdBkXrChD53bRC+a0Y3O5kAhjWlUoxrS7U2xihcMxRZ/2poUCLWoJ/zkGZcazlSJc5xZ7etfb9fVZYa1rA/N5DXb+tbZ7SylnZ0kaL83wcN+NZJjbezM0noQ21Z0jL29bGa7udmSHne4X32FQVQX2+vWNrcV/e5vf9vc8z5yjNF97XUfut3ufrey4/3veMsT39gOCAA7"

/***/ }),

/***/ "LKlI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieEN_vue__ = __webpack_require__("3aAj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdc49ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PieEN_vue__ = __webpack_require__("L9DZ");
function injectStyle (ssrContext) {
  __webpack_require__("ZG7H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fdc49ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieEN_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdc49ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PieEN_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LUhn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LqK3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.470ce4b.jpg";

/***/ }),

/***/ "LvNC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_en_vue__ = __webpack_require__("0hkm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780987c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_info_en_vue__ = __webpack_require__("KWvv");
function injectStyle (ssrContext) {
  __webpack_require__("NjgU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-780987c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780987c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_info_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LzmR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video.86d53dd.mp4";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66116a00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("BesW");
function injectStyle (ssrContext) {
  __webpack_require__("o9L2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66116a00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MINx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MnXy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N1q+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2c.9075465.png";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("8+8L");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);

/***/ }),

/***/ "NPcl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NSw+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestrosComienzos_en_vue__ = __webpack_require__("f2zm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eaa3a42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestrosComienzos_en_vue__ = __webpack_require__("OZm9");
function injectStyle (ssrContext) {
  __webpack_require__("AxVR")
  __webpack_require__("+6Yu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eaa3a42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestrosComienzos_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eaa3a42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestrosComienzos_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NjgU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O5dg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.5977a7b.jpg";

/***/ }),

/***/ "O6oy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.dae0b15.jpg";

/***/ }),

/***/ "OD3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("O5dg"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Public Offering")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"caja"},[_c('p',[_vm._v("\n          COMPAÑÍA MEGA S.A. entered the CNV’s Public Offering Regime under\n          resolution RESFC-2019-20543-APN-DIR#CNV dated November 7, 2019.\n          For more information on the company and the capital market, you can visit the\n          official web "),_c('a',{attrs:{"target":"_blank","href":"https://www.cnv.gov.ar/SitioWeb/Empresas"}},[_vm._v(" site of the CNV")]),_vm._v(" (Argentina’s National Securities Commission for its Spanish acronym) (*)\n        ")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("(*) This is a link to the CNV’s web site. The CNV is not part of this Company, therefore, (agregar Compañía, en castellano tambien) Compañia Mega S.A. is not responsible for the accuracy of the information included therein or for supplementing, updating or correcting said information.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OFxn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAfCAIAAAAA3/ihAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBGRjg4N0RDRTk2QTExRUI5RDMwRjZCNjgyNTc0RDREIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBGRjg4N0RERTk2QTExRUI5RDMwRjZCNjgyNTc0RDREIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEZGODg3REFFOTZBMTFFQjlEMzBGNkI2ODI1NzRENEQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEZGODg3REJFOTZBMTFFQjlEMzBGNkI2ODI1NzRENEQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7nQA9bAAABzUlEQVR42mJk8J3HQC/AxEBHMHwtY8EjVxdh4Kgr+eHrr441l07eek1Dy2ZlW6e6q0HYARZy6plrbz39RKtghNsEAYnOqjSMs6dvvyFzrz/5SEPLYvoOvv38E8Jeefj+on13KLeMEU+mZmNhMlERef/11/XHH2ieGn/9+XfsxisiDZIR4WZiZHj85uv//6Rb1hhl6Kwv9e/ff0ZGEDeu//D9l581ZPhn51hDjGNiYlx28O60bTfCbBSrQvX0FYUgMb366P2y+Wd+//1HgmX2OhLWmmJwrgA3G5AU5mW30RKHC155+D7HW3NyugVcRFqYq8BP28tY1rBg47eff4hNIC8/fEcN0r9A8udvFPfGOCgj2wQHatJ8iwptqVxccXOAAubMnTdbTj/+/usvslSwlQJpCYQYUL7gTNe6y0CGlBDXqV5fYDBCxDHDkFKfnbr1GmITEDx79w3OBoK///5T2bIzd94ic+88/0TDKoadFUU7MxMjDS1jYmTEwx1tFgxry4CZFDXhMQNJDjZmZEEJQU5kLg8nK5zNi8QmXIJsO/MEWArA6wtIRQosMHeeewpk/AelPYY9F58ha7n34jNEFlcJwjjaIh61DB8ACDAAepOoBN9zneQAAAAASUVORK5CYII="

/***/ }),

/***/ "OZm9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"nuestrosComienzos"},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Nuestros Comienzos")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("El desafío comenzó hace tiempo cuando la sociedad integrada por YPF S.A., Petrobras y Dow Argentina decidió a mediados de 1997 concretar un proyecto que explotara integralmente el gas natural. Así, con la concreción del mismo, los componentes ricos del gas natural pasaron a constituir el insumo básico de la industria del plástico, permitiendo la expansión de dicha industria fundamental para el crecimiento de la economía argentina.\n          ")]),_vm._v(" "),_c('p',[_vm._v("La inversión total del proyecto fue de U$S 715 millones, formados aproximadamente por U$S 506 millones de “hard costs”(ingeniería, provisión de equipos y construcción) y U$S 209 millones de “soft costs” (costos pre-operativos y de desarrollo, costos financieros, impuestos y otros). La financiación provino de préstamos a través de obligaciones negociables y del aporte de los socios.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("id2H"),"alt":""}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OdV2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Feb-2019-organigrama.83e470c.jpg";

/***/ }),

/***/ "Ofkk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'esquemaDelProceso'
});

/***/ }),

/***/ "Oj/C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.c0e2071.jpg";

/***/ }),

/***/ "OjGd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1c.6cd96d5.png";

/***/ }),

/***/ "PRjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('cabeceraEN'),_vm._v(" "),_c('section',{staticClass:"video-cont"},[_c('video',{staticClass:"video",attrs:{"playsinline":"","autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":__webpack_require__("Df+U"),"type":"video/mp4"}})]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('section',{staticClass:"novedades"},[_c('router-link',{staticClass:"modulo-nov",attrs:{"to":{name: 'medioAmbienteEN'}}},[_c('h4',[_vm._v("Quality, Safety, Health and Environment")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("djE1"),"alt":""}})]),_vm._v(" "),_c('router-link',{staticClass:"modulo-nov",attrs:{"to":{name: 'quienesSomosEN', hash: '#comercializacion'}}},[_c('h4',[_vm._v("Production and Commercial Process")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("1cIH"),"alt":""}})]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('router-link',{staticClass:"modulo-nov",attrs:{"to":{name: 'medioAmbienteEN', hash: '#sistema-de-gestion'}}},[_c('h4',[_vm._v("Learn About our Integrated Management System")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("yhq2"),"alt":""}})])],1),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caja"},[_c('h1',[_vm._v("We add value"),_c('br'),_c('strong',[_vm._v("to energy")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"compania"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-10 col-md-8 text-center"},[_c('h1',[_vm._v("Compañía Mega S.A.")]),_vm._v(" "),_c('p',{staticClass:"bajada"},[_c('strong',[_vm._v("Compañía Mega")]),_vm._v(" is an Argentine company whose origin dates back to April 2001. Its main\n            business is to add value to natural gas through the separation and fractionation of its rich\n            components. It recovers ethane, which is one of the main feedstock used in the Argentine\n            petrochemical industry, and uses the rest of the liquid components (propane, butane and\n            natural gasoline) for other markets. It is a public limited company whose shareholders are\n            YPF S.A., Petrobras and Dow Argentina.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"premio"},[_c('div',{staticClass:"obrero"}),_vm._v(" "),_c('div',{staticClass:"circulo"},[_c('img',{attrs:{"src":__webpack_require__("xITy"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modulo-nov"},[_c('h4',[_vm._v("Download Institutional Brochure")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("SDQw"),"alt":""}}),_vm._v(" "),_c('a',{staticClass:"esp",attrs:{"href":"static/pdf/Español.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("0Cg+"),"alt":""}})]),_vm._v(" "),_c('a',{staticClass:"en",attrs:{"href":"static/pdf/Ingles.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("hUnK"),"alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pkht":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.3505873.jpg";

/***/ }),

/***/ "PxaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabecera'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pie')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("Gksi"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Proveedores")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-6"},[_c('p',{staticClass:"text-center"},[_vm._v("En caso de dudas de navegación del portal Ariba, por favor, acceda a nuestro "),_c('strong',[_vm._v("Centro de Ayuda")]),_vm._v(" ubicado en la esquina superior derecha de su cuenta.")]),_vm._v(" "),_c('div',{staticClass:"bnt"},[_c('a',{attrs:{"target":"_blank","href":"https://service.ariba.com/Supplier.aw/125042059/aw?awh=r&awssk=Y4TW9pUw&dard=1&ancdc=1"}},[_vm._v("Acceso"),_c('br'),_vm._v(" ARIBA Network")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/MEGA - Manual Ariba Proveedores.pdf"}},[_vm._v("manual"),_c('br'),_vm._v(" de proveedores")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q2N1":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQwNjNFNTUxRTk2NDExRUI4MDg3RjNDNzdEQkRDMjVCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQwNjNFNTUyRTk2NDExRUI4MDg3RjNDNzdEQkRDMjVCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDA2M0U1NEZFOTY0MTFFQjgwODdGM0M3N0RCREMyNUIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDA2M0U1NTBFOTY0MTFFQjgwODdGM0M3N0RCREMyNUIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7PcNLbAAABDUlEQVR42mJkQAa+88SBZA4QewCxMlT0PhDvBOLJDJuTnsOUMiJpCgeSs4GYlwE7+ArE6UDNSxEafecFAMn1DMSBMKDm1YxATUJAzhsU2xkY2oDYEogdcWgWZwISpWiaQOAQ0FQnIH0Zh8ZKkMYALBI7gC6JBGrWA7IvYpH3AWmUx2HqMqDmHKBmAyD7NJqcFBOBgGCF0v/QxBlBGh/h0BQPtK0faOspINscTe4ZSOMmbH4AaloE1HQWyDbFIr8NFB0iQMZrNIkWILYAYhccrpGEJYBQILmKyAQQDXTNMkjgAFMCkIwB4u94NPwC4kSQJgaMiPedJwMk84DYFRpNIPmHQLwHmsgfwpQCBBgAJDE+I5nn3ZQAAAAASUVORK5CYII="

/***/ }),

/***/ "Q6QH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gobierno_en_vue__ = __webpack_require__("acAa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc3cafe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gobierno_en_vue__ = __webpack_require__("IKix");
function injectStyle (ssrContext) {
  __webpack_require__("Eyqf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dc3cafe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gobierno_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc3cafe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gobierno_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QHPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lineaEtica_vue__ = __webpack_require__("zeFF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_661876a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lineaEtica_vue__ = __webpack_require__("7XvG");
function injectStyle (ssrContext) {
  __webpack_require__("EckT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-661876a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lineaEtica_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_661876a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lineaEtica_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QkJJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R43U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"organizacion"},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Organización")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_c('strong',[_vm._v("Compañía Mega S.A.")]),_vm._v(" cuenta con un grupo humano altamente calificado y con la experiencia necesaria para operar con excelencia en la gestión de cada uno de los procesos que conforman la empresa.")]),_vm._v(" "),_c('p',[_vm._v("Alineada con su Política de Gestión, la organización está orientada al desarrollo de sus actividades con eficiencia y calidad en cada una de sus áreas.")])])])])]),_vm._v(" "),_c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h2',[_vm._v("Áreas de la compañía")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("OdV2"),"alt":"Organigrama"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RJFY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nuestras-plantas.9c65655.jpg";

/***/ }),

/***/ "RwWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Pie__ = __webpack_require__("iPQG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gobierno',
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_1__components_Pie__["a" /* default */]
  }
});



__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).toggleClass('active');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.profile .box').toggleClass('open');
  });
});

/***/ }),

/***/ "S2so":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "SDQw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.bb01749.png";

/***/ }),

/***/ "SDdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cabecera_vue__ = __webpack_require__("CEDn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21ba7f11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cabecera_vue__ = __webpack_require__("evdj");
function injectStyle (ssrContext) {
  __webpack_require__("46l/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21ba7f11"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cabecera_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21ba7f11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cabecera_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SDkT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAIAAAAym6IDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjkxOTA0RTdBRThDNzExRUI5NUI1QkQ0OEZFRkFCMjkwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjkxOTA0RTdCRThDNzExRUI5NUI1QkQ0OEZFRkFCMjkwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OTE5MDRFNzhFOEM3MTFFQjk1QjVCRDQ4RkVGQUIyOTAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OTE5MDRFNzlFOEM3MTFFQjk1QjVCRDQ4RkVGQUIyOTAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4fzv+OAAABpUlEQVR42rRTS0vDQBCe2SQtNlF84KmXgtCKB68evPgD/BXePYjefNwF6UXwh4h36VFEEFRUxEoFFVt80TRxd7M7bjdCX3rw4DCESfJ9s998mWC9Xoc/BoO/h9t37zWPcvdlFlVRCsKM8qfiwoocmevGYJc2Gq6uetEt+jOkJCQJJIJESO8XMr/QKu0YcL+2oLaRUa8YlEB/guKgPkFzg8Og6N5V/JvN/nmc+DrbOsbMhEXzNk0LW5iUkB13qwdOdN3D8R/KGExbhG2vhD1HpC2QMVA4dFvu4bitU9OPetqnBEGakykM5u2sxzfUrTZBKVAJ6ETzSI7Nm6dmatY8x0atDeLRgNemsZGuFRlOdjIurretJDLX3OWWW90HW3e0EculekhbD0CRjfRtVNrs/vjfZeLPgmh8j5FmVxC66Hj9nCi/BrwBSZgawPhDh0DkxDWScuCcoWk+sQjiBeSH4aASwdVyKg+Tpn+y9PO+hYVtVLFXPzQ2gEb3qTLamCNvDMNnEr/uNTandsOZPTVSRM8Bh1DHLH5EptDTNmlwR//z//kSYADLPgbb8CrxoAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Sp5t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/20.d95d2d2.png";

/***/ }),

/***/ "SvJk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pie',
  props: ['empresa']
});

/***/ }),

/***/ "TLci":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/planta.310aab7.jpg";

/***/ }),

/***/ "TRbM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Sistema de Gestión Integrado")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_c('strong',[_vm._v("Compañía Mega S.A.")]),_vm._v(", implementó un Sistema de Gestión certificado el 1 de noviembre de 2002 a través de una auditoría externa. Hoy acredita el cumplimiento de los requisitos de ISO 9001:2015 (Sistemas de Gestión de la Calidad), ISO 14001:2015(Sistemas de Gestión Ambiental) y OHSAS18001:2007 (Sistemas de Gestión de la Seguridad y Salud Ocupacional en el Trabajo), aplicables a su proceso de separación, transporte, fraccionamiento y almacenamiento de los componentes líquidos del gas natural, despacho y venta de productos.")]),_vm._v(" "),_c('h5',[_vm._v("La Implementación")]),_vm._v(" "),_c('p',[_vm._v("La implementación de un Sistema Integrado de Gestión basado en las Normas ISO 9000-2000, ISO 14001-1996 e IRAM 3800-1998 fue un desafío para la Compañía, teniendo en cuenta las diferentes localizaciones, culturas y procesos operativos. Esto significó una optimización de los procesos y una mejora en los estándares de la Compañía.")]),_vm._v(" "),_c('h5',[_vm._v("La Política y el Manual de Gestión")]),_vm._v(" "),_c('p',[_vm._v("La Política de Gestión de la Compañía se apoya en Principios de Dirección alineados con los compromisos de YPF, Dow y Petrobras con la Calidad, la Seguridad, la Salud y el Medio Ambiente. Por su esmero y dedicación en la calidad de su gestión, Compañía Mega obtuvo importantes premios.")]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/politica.png","target":"_blank"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("VER POLITICA DE GESTIÓN")])]),_vm._v(" "),_c('p',[_vm._v("Como parte de este proceso la Compañía emitió su Manual de Gestión y realizó su comunicación formal en la Organización.")]),_vm._v(" "),_c('div',{staticClass:"cont-pdf"},[_c('a',{attrs:{"href":"static/pdf/Certificado-9001-2015.pdf","target":"_blank"}},[_c('img',{staticClass:"pdf",attrs:{"src":__webpack_require__("bePC"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/Certificado-14001-2015.pdf","target":"_blank"}},[_c('img',{staticClass:"pdf",attrs:{"src":__webpack_require__("2U+m"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/Certificado-18001-2007.pdf","target":"_blank"}},[_c('img',{staticClass:"pdf",attrs:{"src":__webpack_require__("3urk"),"alt":""}})])])])])])]),_vm._v(" "),_c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h2',[_vm._v("Premio Nacional a la calidad 2006")]),_vm._v(" "),_c('p',[_vm._v("Como consecuencia de su esmero y dedicación en la calidad de su gestión, Compañía Mega S.A. fue galardonada en el año 2006 con el Premio Nacional a la Calidad que distingue la excelencia en calidad de gestión. La entrega del premio se efectuó en un acto llevado a cabo en la Casa de Gobierno con la presencia del Sr. Presidente de la Nación, Néstor Kirchner, quien hiciera entrega del mismo.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("twXY"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("El Premio Nacional a la Calidad es un sistema de evaluación integrado, a partir de un modelo ideal de empresa de alta competencia, y es otorgado anualmente por la Nación Argentina a través del Presidente de la Nación. Asimismo, es organizado y administrado por la Fundación Premio Nacional a la Calidad, creada para ese fin.")]),_c('p'),_c('p',[_vm._v("Fue instituido por la ley 24.127 en 1994, con el objetivo de promover el desarrollo de los procesos y sistemas destinados al mejoramiento continuo de la calidad en los productos y servicios, a fin de fomentar la modernización y competitividad del sector empresario.")]),_vm._v(" "),_c('p',[_vm._v("Pueden concursar pequeñas, medianas o grandes empresas, tanto de servicios como de producción de bienes, que tengan como mínimo una continuidad operativa de 3 años en el país.")]),_vm._v(" "),_c('p',[_vm._v("La evaluación de las organizaciones está a cargo de una junta de evaluadores compuesta por jueces y examinadores seleccionados por concurso abierto que actúa en forma independiente de la Fundación.")]),_c('p'),_c('p',[_vm._v("Implica un riguroso proceso, que se extiende a lo largo de 4 meses y consta de 3 etapas bien diferenciadas: en la primera, un grupo no menor de 5 examinadores estudian en forma independiente las fortalezas y los aspectos a mejorar de los 28 criterios del premio, aplicables a cada postulante, y le asignan puntaje. En la segunda etapa, estos examinadores se reúnen para consensuar los resultados obtenidos para cada empresa. Por último, en la tercera etapa, las empresas seleccionadas reciben la visita del equipo de examinadores.")]),_vm._v(" "),_c('p',[_vm._v("Examinadores y jueces realizan esta tarea ad honorem y cada empresa evaluada insume en promedio 765 horas profesionales que se plasman en el informe de retroalimentación que reciben las empresas participantes, independientemente del resultado del concurso.")]),_vm._v(" "),_c('p',[_vm._v("El premio se instauró en el año 1992, y entre los ganadores se encuentran empresas de diferentes rubros y categorías tales como Unilever de Argentina S.A. (División Limpieza y Cuidado Personal), Hotel Intercontinental, Telecom Personal S.A., Nextel Argentina, 3M Argentina, Siderar, División Lubricantes de Repsol YPF, Taranto San Juan S.A. y Volkswagen Argentina Centro Industrial Córdoba, entre otras.")]),_vm._v(" "),_c('a',{staticClass:"link-azul",attrs:{"href":"http://www.fundece.org.ar","target":"_blank"}},[_vm._v("www.FUNDECE.org.ar")])])])])]),_vm._v(" "),_c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h2',[_vm._v("Premio Oro Iberoamericano a la calidad año 2008")]),_vm._v(" "),_c('p',[_vm._v("El Premio Iberoamericano de la Calidad es un Programa Oficial de la Cumbre Iberoamericana de Jefes de Estado y de Gobierno, basado en el Modelo Iberoamericano de Excelencia en la Gestión y gestionado por FUNDIBEQ.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("+fWr"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("Al Premio Iberoamericano de la Calidad pueden acceder las Organizaciones Iberoamericanas tanto públicas como privadas de Iberoamérica.")]),_vm._v(" "),_c('p',[_vm._v("Este Premio es desarrollado gracias a la colaboración de los Premios Nacionales y Regionales Asociados de los diferentes países de Iberoamérica y tiene por objeto:")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Reconocer la Calidad de las organizaciones premiadas en el contexto internacional y con ello contribuir a que la Comunidad Iberoamericana sea considerada un entorno de Calidad, donde encontrar los mejores proveedores, aliados y oportunidades de inversión.")]),_vm._v(" "),_c('li',[_vm._v("Estimular el desarrollo de las organizaciones iberoamericanas, ofreciendo un Modelo que permite compararse con organizaciones excelentes a nivel internacional.")]),_vm._v(" "),_c('li',[_vm._v("Promover la Auto-evaluación y la focalización hacia la satisfacción de las necesidades y expectativas del cliente y de las partes interesadas.")])])]),_vm._v(" "),_c('p',[_vm._v("Compañía Mega S.A. fue galardonada en el año 2008 con el PREMIO ORO IBEROAMERICANO A LA CALIDAD, en la categoría PRIVADA MEDIANA. Esta premiación nos llena de orgullo y nos refuerza en nuestro constante compromiso con la calidad de toda nuestra gestión.")]),_vm._v(" "),_c('a',{staticClass:"link-azul",attrs:{"href":"http://www.fundibeq.org","target":"_blank"}},[_vm._v("www.FUNDIBEQ.org")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TUUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'esquemaDelProceso'
});

/***/ }),

/***/ "ThYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('cabecera'),_vm._v(" "),_c('section',{staticClass:"video-cont"},[_c('video',{staticClass:"video",attrs:{"playsinline":"","autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":__webpack_require__("5ze/"),"type":"video/mp4"}})]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('section',{staticClass:"novedades"},[_c('router-link',{staticClass:"modulo-nov",attrs:{"to":{name: 'medioAmbiente'}}},[_c('h4',[_vm._v("Calidad, Seguridad, Salud y Medio Ambiente")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Icca"),"alt":""}})]),_vm._v(" "),_c('router-link',{staticClass:"modulo-nov",attrs:{"to":{name: 'quienesSomos', hash: '#comercializacion'}}},[_c('h4',[_vm._v("Proceso Productivo y Comercial")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Iz3u"),"alt":""}})]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('router-link',{staticClass:"modulo-nov",attrs:{"to":{name: 'medioAmbiente', hash: '#sistema-de-gestion'}}},[_c('h4',[_vm._v("Conocé nuestro Sistema de Gestión Integrado")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("aafJ"),"alt":""}})])],1),_vm._v(" "),_c('pie')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caja"},[_c('h1',[_vm._v("Agregamos valor"),_c('br'),_c('strong',[_vm._v("a la energía")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"compania"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-10 col-md-8 text-center"},[_c('h1',[_vm._v("Compañía Mega S.A.")]),_vm._v(" "),_c('p',{staticClass:"bajada"},[_c('strong',[_vm._v("Compañía Mega")]),_vm._v(" es una empresa argentina que opera desde abril del 2001. Tiene como eje principal del negocio agregar valor al gas natural a través de la separación y el fraccionamiento de sus componentes ricos. Recupera el etano, que constituye una de las principales materias primas de la industria petroquímica argentina, y aprovecha el resto de los componentes líquidos (propano, butano y gasolina natural) para otros mercados. Es una sociedad anónima cuyos accionistas son YPF S.A., Petrobras y Dow Argentina.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"premio"},[_c('div',{staticClass:"obrero"}),_vm._v(" "),_c('div',{staticClass:"circulo"},[_c('img',{attrs:{"src":__webpack_require__("Sp5t"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modulo-nov"},[_c('h4',[_vm._v("Descargar folleto institucional")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("wXvF"),"alt":""}}),_vm._v(" "),_c('a',{staticClass:"esp",attrs:{"href":"static/pdf/Español.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("8IwT"),"alt":""}})]),_vm._v(" "),_c('a',{staticClass:"en",attrs:{"href":"static/pdf/Ingles.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("3hEQ"),"alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TuIl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.89dcf39.jpg";

/***/ }),

/***/ "U2vJ":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "U9Kg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "UIPr":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "UcMC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4c.c2c689b.png";

/***/ }),

/***/ "Ugd8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.5977a7b.jpg";

/***/ }),

/***/ "UlF2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.1e54a9a.png";

/***/ }),

/***/ "UwE+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V2ZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Organizacion'
});

/***/ }),

/***/ "VphK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabecera'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pie')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("ziWI"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Información Financiera")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"caja"},[_c('h5',[_vm._v("Estados Financieros Anuales")]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"box"},[_c('p',[_vm._v("Estados financieros")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2022.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2022")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',[_vm._v("Estados financieros")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2021.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2021")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',[_vm._v("Estados financieros")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2020.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2020")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',[_vm._v("Estados financieros")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2019.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2019")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',[_vm._v("Estados financieros")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2018.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2018")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',[_vm._v("Estados financieros")]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF2017.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("2017")])])])])]),_vm._v(" "),_c('h5',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Estados Financieros Intermedios")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Estados Financieros Intermedios cerrados el 31/03/2022"),_c('a',{attrs:{"target":"_blank","href":"static/pdf/Cia Mega - EEFF 31 de marzo 2022 (VF).pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Estados Financieros Intermedios cerrados el 30/09/2021"),_c('a',{attrs:{"target":"_blank","href":"static/pdf/Cia Mega - EEFF 30 de septiembre 2021 (VF).pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Estados Financieros Intermedios cerrados el 30/06/2021 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/Cia Mega - EEFF 30 de junio 2021 (VF).pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Estados Financieros Intermedios cerrados el 31/03/2021 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF 31 de marzo 2021.pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Estados Financieros Intermedios cerrados el 30/09/2020 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF-30-sept-2020.pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Estados Financieros Intermedios cerrados el 30/06/2020 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF-30-junio-2020.pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Estados Financieros Intermedios cerrados el 31/03/2020 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/EEFF 31 de marzo de 2020 (COMPLETO).pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('h5',{staticStyle:{"margin-top":"35px"}},[_vm._v("Prospectos")]),_vm._v(" "),_c('p',[_vm._v("Prospecto del Programa Global de Emisión de ONs no convertibles en acciones por un valor nominal de hasta U$S 500.000 - 24 de junio de 2020 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/Prospecto - Compañia Mega SA.pdf"}},[_c('i',{staticClass:"icon-file-pdf"})]),_c('br'),_c('br'),_vm._v("\n        Prospecto Resumido del Programa Global de Emisión de ONs no convertibles en acciones por un valor nominal de hasta U$S 500.000 - 24 de junio de 2020 "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/Prospecto Resumido - Compañia Mega SA.pdf"}},[_c('i',{staticClass:"icon-file-pdf"})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VtoR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WGgP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ariba'
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.profile .box').toggleClass('open');
  });
});

/***/ }),

/***/ "Wr/z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wsrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_enviarCV_vue__ = __webpack_require__("p6f9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e6c13ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_enviarCV_vue__ = __webpack_require__("YM1I");
function injectStyle (ssrContext) {
  __webpack_require__("LUhn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e6c13ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_enviarCV_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e6c13ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_enviarCV_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WxGP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/becas2021.92dec1f.png";

/***/ }),

/***/ "Wxwp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ariba'
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.profile .box').toggleClass('open');
  });
});

/***/ }),

/***/ "X6vt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_proveedores_en_vue__ = __webpack_require__("z1q/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b00473f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_proveedores_en_vue__ = __webpack_require__("d/Lt");
function injectStyle (ssrContext) {
  __webpack_require__("xorr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b00473f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_proveedores_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b00473f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_proveedores_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XXeL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_en_vue__ = __webpack_require__("A57j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00de8697_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_en_vue__ = __webpack_require__("PRjU");
function injectStyle (ssrContext) {
  __webpack_require__("HzIW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00de8697"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00de8697_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xe9c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/planta.3e6849c.jpg";

/***/ }),

/***/ "XsLF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certificado-18001-2007.748f86b.jpg";

/***/ }),

/***/ "Y4ea":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_esquemaDelProceso_vue__ = __webpack_require__("TUUi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f3a0ea1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_esquemaDelProceso_vue__ = __webpack_require__("7d7a");
function injectStyle (ssrContext) {
  __webpack_require__("ah9d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f3a0ea1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_esquemaDelProceso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f3a0ea1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_esquemaDelProceso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YM1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Enviar CV")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("Si desea formar parte del equipo de Compañía Mega S.A., por favor envíenos su C.V. a la siguiente dirección")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:megacomunicaciones@ciamega.com.ar"}},[_vm._v("megacomunicaciones@ciamega.com.ar")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_Home__ = __webpack_require__("h6qm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_en_Home_en__ = __webpack_require__("XXeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_nuestra_empresa_nuestraEmpresa__ = __webpack_require__("KR7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_nuestra_empresa_en_nuestraEmpresa_en__ = __webpack_require__("65zn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_nuestros_comienzos_nuestrosComienzos__ = __webpack_require__("ywzX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_nuestros_comienzos_en_nuestrosComienzos_en__ = __webpack_require__("NSw+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_organizacion_Organizacion__ = __webpack_require__("3Id5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_organizacion_en_Organizacion_en__ = __webpack_require__("tZhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_nuestras_plantas_nuestrasPlantas__ = __webpack_require__("gr5J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_nuestras_plantas_en_nuestrasPlantas_en__ = __webpack_require__("0/OY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_esquema_esquemaDelProceso__ = __webpack_require__("Y4ea");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_esquema_en_esquemaDelProceso_en__ = __webpack_require__("h3ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_medio_ambiente_medioAmbiente__ = __webpack_require__("iApg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_medio_ambiente_en_medioAmbiente_en__ = __webpack_require__("2qBd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_sistema_de_gestion_sistemaDeGestion__ = __webpack_require__("+IIF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_sistema_de_gestion_en_sistemaDeGestion_en__ = __webpack_require__("J/5I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_relaciones_institucionales_relacionesInstitucionales__ = __webpack_require__("j9oL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_relaciones_institucionales_en_relacionesInstitucionales_en__ = __webpack_require__("9NjF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_enviar_cv_enviarCV__ = __webpack_require__("Wsrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_enviar_cv_en_enviarCV_en__ = __webpack_require__("/LYx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_proveedores_proveedores__ = __webpack_require__("H+TH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_proveedores_en_proveedores_en__ = __webpack_require__("X6vt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_contactenos_contactenos__ = __webpack_require__("nM/A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_contactenos_en_contactenos_en__ = __webpack_require__("pD7+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_linea_etica_lineaEtica__ = __webpack_require__("QHPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_linea_etica_en_lineaEtica_en__ = __webpack_require__("hUk2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_quienes_somos_quienesSomos__ = __webpack_require__("wq+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_quienes_somos_en_quienesSomos_en__ = __webpack_require__("sIId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_ariba_ariba__ = __webpack_require__("aHNH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_ariba_en_ariba_en__ = __webpack_require__("IyOV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_regimen_regimen__ = __webpack_require__("kfvk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_regimen_en_regimen_en__ = __webpack_require__("3iIt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_info_info__ = __webpack_require__("4iyI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_info_en_info_en__ = __webpack_require__("LvNC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_gobierno_gobierno__ = __webpack_require__("JE62");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_gobierno_en_gobierno_en__ = __webpack_require__("Q6QH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_contact_contact__ = __webpack_require__("+QH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_contact_en_contact_en__ = __webpack_require__("H0lJ");












































__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/home/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_5__components_home_Home__["a" /* default */]
  }, {
    path: '/home-en/',
    name: 'HomeEN',
    component: __WEBPACK_IMPORTED_MODULE_6__components_home_en_Home_en__["a" /* default */]
  }, {
    path: '/nuestraEmpresa/',
    name: 'nuestraEmpresa',
    component: __WEBPACK_IMPORTED_MODULE_7__components_nuestra_empresa_nuestraEmpresa__["a" /* default */]
  }, {
    path: '/nuestraEmpresa-en/',
    name: 'nuestraEmpresaEN',
    component: __WEBPACK_IMPORTED_MODULE_8__components_nuestra_empresa_en_nuestraEmpresa_en__["a" /* default */]
  }, {
    path: '/nuestrosComienzos/',
    name: 'nuestrosComienzos',
    component: __WEBPACK_IMPORTED_MODULE_9__components_nuestros_comienzos_nuestrosComienzos__["a" /* default */]
  }, {
    path: '/nuestrosComienzos-en/',
    name: 'nuestrosComienzosEN',
    component: __WEBPACK_IMPORTED_MODULE_10__components_nuestros_comienzos_en_nuestrosComienzos_en__["a" /* default */]
  }, {
    path: '/organizacion/',
    name: 'Organizacion',
    component: __WEBPACK_IMPORTED_MODULE_11__components_organizacion_Organizacion__["a" /* default */]
  }, {
    path: '/organizacion-en/',
    name: 'OrganizacionEN',
    component: __WEBPACK_IMPORTED_MODULE_12__components_organizacion_en_Organizacion_en__["a" /* default */]
  }, {
    path: '/nuestras-plantas/',
    name: 'nuestrasPlantas',
    component: __WEBPACK_IMPORTED_MODULE_13__components_nuestras_plantas_nuestrasPlantas__["a" /* default */]
  }, {
    path: '/nuestras-plantas-en/',
    name: 'nuestrasPlantasEN',
    component: __WEBPACK_IMPORTED_MODULE_14__components_nuestras_plantas_en_nuestrasPlantas_en__["a" /* default */]
  }, {
    path: '/esquema/',
    name: 'esquemaDelProceso',
    component: __WEBPACK_IMPORTED_MODULE_15__components_esquema_esquemaDelProceso__["a" /* default */]
  }, {
    path: '/esquema-en/',
    name: 'esquemaDelProcesoEN',
    component: __WEBPACK_IMPORTED_MODULE_16__components_esquema_en_esquemaDelProceso_en__["a" /* default */]
  }, {
    path: '/medio-ambiente/',
    name: 'medioAmbiente',
    component: __WEBPACK_IMPORTED_MODULE_17__components_medio_ambiente_medioAmbiente__["a" /* default */]
  }, {
    path: '/medio-ambiente-en/',
    name: 'medioAmbienteEN',
    component: __WEBPACK_IMPORTED_MODULE_18__components_medio_ambiente_en_medioAmbiente_en__["a" /* default */]
  }, {
    path: '/sistema-de-gestion/',
    name: 'sistemaDeGestion',
    component: __WEBPACK_IMPORTED_MODULE_19__components_sistema_de_gestion_sistemaDeGestion__["a" /* default */]
  }, {
    path: '/sistema-de-gestion-en/',
    name: 'sistemaDeGestionEN',
    component: __WEBPACK_IMPORTED_MODULE_20__components_sistema_de_gestion_en_sistemaDeGestion_en__["a" /* default */]
  }, {
    path: '/relaciones-institucionales/',
    name: 'relacionesInstitucionales',
    component: __WEBPACK_IMPORTED_MODULE_21__components_relaciones_institucionales_relacionesInstitucionales__["a" /* default */]
  }, {
    path: '/relaciones-institucionales-en/',
    name: 'relacionesInstitucionalesEN',
    component: __WEBPACK_IMPORTED_MODULE_22__components_relaciones_institucionales_en_relacionesInstitucionales_en__["a" /* default */]
  }, {
    path: '/enviar-cv/',
    name: 'enviarCV',
    component: __WEBPACK_IMPORTED_MODULE_23__components_enviar_cv_enviarCV__["a" /* default */]
  }, {
    path: '/enviar-cv-en/',
    name: 'enviarCVEN',
    component: __WEBPACK_IMPORTED_MODULE_24__components_enviar_cv_en_enviarCV_en__["a" /* default */]
  }, {
    path: '/contactenos/',
    name: 'contactenos',
    component: __WEBPACK_IMPORTED_MODULE_27__components_contactenos_contactenos__["a" /* default */]
  }, {
    path: '/contactenos-en/',
    name: 'contactenosEN',
    component: __WEBPACK_IMPORTED_MODULE_28__components_contactenos_en_contactenos_en__["a" /* default */]
  }, {
    path: '/linea-etica/',
    name: 'lineaEtica',
    component: __WEBPACK_IMPORTED_MODULE_29__components_linea_etica_lineaEtica__["a" /* default */]
  }, {
    path: '/linea-etica-en/',
    name: 'lineaEticaEN',
    component: __WEBPACK_IMPORTED_MODULE_30__components_linea_etica_en_lineaEtica_en__["a" /* default */]
  }, {
    path: '/quienes-somos/',
    name: 'quienesSomos',
    component: __WEBPACK_IMPORTED_MODULE_31__components_quienes_somos_quienesSomos__["a" /* default */]
  }, {
    path: '/quienes-somos-en/',
    name: 'quienesSomosEN',
    component: __WEBPACK_IMPORTED_MODULE_32__components_quienes_somos_en_quienesSomos_en__["a" /* default */]
  }, {
    path: '/ariba/',
    name: 'ariba',
    component: __WEBPACK_IMPORTED_MODULE_33__components_ariba_ariba__["a" /* default */]
  }, {
    path: '/ariba-en/',
    name: 'aribaEN',
    component: __WEBPACK_IMPORTED_MODULE_34__components_ariba_en_ariba_en__["a" /* default */]
  }, {
    path: '/proveedores/',
    name: 'proveedores',
    component: __WEBPACK_IMPORTED_MODULE_25__components_proveedores_proveedores__["a" /* default */]
  }, {
    path: '/proveedores-en/',
    name: 'proveedoresEN',
    component: __WEBPACK_IMPORTED_MODULE_26__components_proveedores_en_proveedores_en__["a" /* default */]
  }, {
    path: '/regimen-oferta-publica/',
    name: 'regimen',
    component: __WEBPACK_IMPORTED_MODULE_35__components_regimen_regimen__["a" /* default */]
  }, {
    path: '/regimen-oferta-publica-en/',
    name: 'regimenEN',
    component: __WEBPACK_IMPORTED_MODULE_36__components_regimen_en_regimen_en__["a" /* default */]
  }, {
    path: '/informacion-financiera/',
    name: 'info',
    component: __WEBPACK_IMPORTED_MODULE_37__components_info_info__["a" /* default */]
  }, {
    path: '/informacion-financiera-en/',
    name: 'infoEN',
    component: __WEBPACK_IMPORTED_MODULE_38__components_info_en_info_en__["a" /* default */]
  }, {
    path: '/gobierno-corporativo/',
    name: 'gobierno',
    component: __WEBPACK_IMPORTED_MODULE_39__components_gobierno_gobierno__["a" /* default */]
  }, {
    path: '/gobierno-corporativo-en/',
    name: 'gobiernoEN',
    component: __WEBPACK_IMPORTED_MODULE_40__components_gobierno_en_gobierno_en__["a" /* default */]
  }, {
    path: '/contact/',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_41__components_contact_contact__["a" /* default */]
  }, {
    path: '/contact-en/',
    name: 'contactEN',
    component: __WEBPACK_IMPORTED_MODULE_42__components_contact_en_contact_en__["a" /* default */]
  }, {
    path: '*',
    name: 'Default',
    component: __WEBPACK_IMPORTED_MODULE_5__components_home_Home__["a" /* default */]
  }],
  scrollBehavior: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, savedPosition) {
      var _this = this;

      var findEl, el;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!savedPosition) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return', savedPosition);

            case 2:
              findEl = function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(hash) {
                  var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          return _context.abrupt('return', document.querySelector(hash) || new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                            if (x > 50) {
                              return resolve(document.querySelector('#app'));
                            }
                            setTimeout(function () {
                              resolve(findEl(hash, ++x || 1));
                            }, 100);
                          }));

                        case 1:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function findEl(_x4) {
                  return _ref2.apply(this, arguments);
                };
              }();

              if (!to.hash) {
                _context2.next = 12;
                break;
              }

              _context2.next = 6;
              return findEl(to.hash);

            case 6:
              el = _context2.sent;

              if (!('scrollBehavior' in document.documentElement.style)) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt('return', window.scrollTo({ top: el.offsetTop, behavior: 'smooth' }));

            case 11:
              return _context2.abrupt('return', window.scrollTo(0, el.offsetTop));

            case 12:
              return _context2.abrupt('return', { x: 0, y: 0 });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function scrollBehavior(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return scrollBehavior;
  }()
}));

/***/ }),

/***/ "YsmI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YuRK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.5977a7b.jpg";

/***/ }),

/***/ "Z+QK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/g-premio.9522114.jpg";

/***/ }),

/***/ "ZCOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabecera'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pie')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("r2Oj"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Contacto")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"caja"},[_c('h2',[_vm._v("Contacto Relaciones con Inversores")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("José Luis Borrello")]),_c('br'),_vm._v("\n          Gerente de Finanzas y Planeamiento Estratégico"),_c('br'),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"mailto:inversores@ciamega.com.ar "}},[_vm._v("inversores@ciamega.com.ar ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZG7H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Znap":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/linea-etica.a90051c.jpg";

/***/ }),

/***/ "a0Mj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sistemaDeGestion'
});

/***/ }),

/***/ "aHNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ariba_vue__ = __webpack_require__("Wxwp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_465f7646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ariba_vue__ = __webpack_require__("w+3j");
function injectStyle (ssrContext) {
  __webpack_require__("kMpX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-465f7646"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ariba_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_465f7646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ariba_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aKyS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.89dcf39.jpg";

/***/ }),

/***/ "aafJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.1b115b6.png";

/***/ }),

/***/ "acAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CabeceraEN__ = __webpack_require__("DPbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PieEN__ = __webpack_require__("LKlI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gobierno',
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_1__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_2__components_PieEN__["a" /* default */]
  }
});



__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.profile .box').toggleClass('open');
  });
});

/***/ }),

/***/ "ah9d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ahZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabecera'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('span',{attrs:{"id":"comercializacion"}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('pie')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("zg+3"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("¿Quiénes somos?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cont-1300"},[_c('div',{staticClass:"left"},[_c('h2',[_vm._v("\n        Nuestros comienzos\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        El desafío comenzó hace tiempo cuando la sociedad integrada por "),_c('strong',[_vm._v("YPF S.A., Petrobras y Dow Argentina ")]),_vm._v(" decidió a mediados de 1997 concretar un proyecto que explotara integralmente el gas natural."),_c('br'),_c('br'),_vm._v("\n\n        Así, con la concreción del mismo, los componentes ricos del gas natural pasaron a constituir el insumo básico de la industria petroquímica, permitiendo la expansión de dicha industria fundamental para el crecimiento de la economía argentina.\n      ")])]),_vm._v(" "),_c('a',{staticClass:"right"},[_c('img',{attrs:{"src":__webpack_require__("UlF2"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cont-1300 left"},[_c('div',{staticClass:"right"},[_c('img',{attrs:{"src":__webpack_require__("aKyS"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"left"},[_c('h2',[_vm._v("\n       Nuestra empresa\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n       Somos una empresa argentina líder en la industria del gas y la petroquímica. Desde 2001 somos un actor clave en el procesamiento del gas natural de la Cuenca Neuquina."),_c('br'),_vm._v("\n\n       Agregamos valor al gas natural a través de la separación y el fraccionamiento de sus componentes ricos. Recuperamos etano, materia prima principal de la industria petroquímica, "),_c('strong',[_vm._v("propano, butano y gasolina natural.")]),_c('br'),_vm._v("\n\n       Nuestros productos abastecen al mercado doméstico y a distintos mercados del mundo, cumpliendo con los estándares más exigentes de calidad internacional. Es una sociedad anónima cuyos accionistas son YPF (38%), Petrobras (34%) y Dow (28%).\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"instalaciones"},[_c('h1',[_vm._v("Nuestras instalaciones")]),_vm._v(" "),_c('div',{staticClass:"cont-1299"},[_c('div',{staticClass:"mod"},[_c('div',{staticClass:"derecha"},[_c('h3',[_vm._v("Planta Separadora Loma La Lata – Neuquén")]),_vm._v(" "),_c('p',[_vm._v("\n            Ubicada en el corazón de la formación de hidrocarburos no convencionales Vaca Muerta."),_c('br'),_c('br'),_vm._v("\n\n            Se abastece por una corriente de gas natural de aproximadamente 40 millones de metros cúbicos estándar por día para alimentar el proceso en el que se retienen líquidos por el equivalente de aproximadamente 5 millones de metros cúbicos por día, retornando el \"gas seco\" o metano a YPF S.A. que lo inyecta en los sistemas troncales de transporte de gas natural (NEUBA II, CENTRO OESTE Y PACIFICO). "),_c('br'),_c('br'),_vm._v("\n\n            Los líquidos retenidos son transportados a través del poliducto de 12 pulgadas de diámetro.\n          ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=Oyc1XsNhQg8"}},[_vm._v("Ver video ")])]),_vm._v(" "),_c('div',{staticClass:"zurda"},[_c('ul',{staticClass:"owl-carousel"},[_c('li',{staticClass:"slide slide1"},[_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=Oyc1XsNhQg8"}},[_c('img',{attrs:{"src":__webpack_require__("FpEW"),"alt":""}})])]),_vm._v(" "),_c('li',{staticClass:"slide slide2"},[_c('img',{attrs:{"src":__webpack_require__("Pkht"),"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"mod"},[_c('div',{staticClass:"derecha derechas"},[_c('h3',[_vm._v("GASODUCTO TRATAYEN")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Neuquén")])]),_vm._v(" "),_c('p',[_vm._v("\n           La obra del gasoducto Tratayen representa una importante inversión para nuestro esquema de abastecimiento productivo, porque nos permite captar parte del gas proveniente del yacimiento Fortín de Piedra y de los futuros desarrollos asociados a la formación Vaca Muerta.\n          ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=BJQR1BmQS48&feature=youtu.be"}},[_vm._v("Ver video ")])]),_vm._v(" "),_c('div',{staticClass:"zurda zurdas"},[_c('ul',{staticClass:"owl-carousel"},[_c('li',{staticClass:"slide slide1"},[_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=BJQR1BmQS48&feature=youtu.be"}},[_c('img',{attrs:{"src":__webpack_require__("t7D0"),"alt":""}})])]),_vm._v(" "),_c('li',{staticClass:"slide slide2"},[_c('img',{attrs:{"src":__webpack_require__("kQMb"),"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"mod"},[_c('div',{staticClass:"derecha"},[_c('h3',[_vm._v("Planta Fraccionadora Bahía Blanca ")]),_vm._v(" "),_c('p',[_vm._v("\n            Situada dentro del Polo Petroquímico más importante del país: Buenos Aires. "),_c('br'),_c('br'),_vm._v("\n\n           \n            En la planta se fraccionan los líquidos, obteniéndose etano,\n            propano, butano y gasolina natural. Además, presenta\n            instalaciones especialmente construidas para el almacenamiento y despacho de propano, butano y gasolina natural."),_c('br'),_c('br'),_vm._v("\n\n            Cuenta con la ventaja competitiva de tener un extraordinario muelle ubicado sobre el canal de Acceso del Complejo Portuario de Bahía Blanca, único puerto de aguas profundas del país, que permite la exportación de productos en buques de gran porte.\n          ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=k1anD59igqU"}},[_vm._v("Ver video ")])]),_vm._v(" "),_c('div',{staticClass:"zurda"},[_c('ul',{staticClass:"owl-carousel"},[_c('li',{staticClass:"slide slide1"},[_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=k1anD59igqU"}},[_c('img',{staticClass:"tercer-btn",attrs:{"src":__webpack_require__("Oj/C"),"alt":""}})])]),_vm._v(" "),_c('li',{staticClass:"slide slide2"},[_c('img',{attrs:{"src":__webpack_require__("7Q4y"),"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"mod"},[_c('div',{staticClass:"derecha derechas"},[_c('h3',[_vm._v("Poliducto de 600 km de longitud")]),_vm._v(" "),_c('p',[_vm._v("\n           Único ducto en Argentina que vincula Vaca Muerta con el puerto internacional de aguas profundas en Bahía Blanca. "),_c('br'),_c('br'),_vm._v("\n\n           Un caño de 12 pulgadas de diámetro que en su trayecto une ambas plantas, atravesando 4 provincias: Neuquén, Río Negro, La Pampa y Buenos Aires.\n          ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"25px"}},[_c('a',{attrs:{"target":"_blank","href":"static/pdf/Folleto-A4-Mega-v2.pdf"}},[_vm._v(" Prevención y Seguridad"),_c('i',{staticClass:"icon-file-pdf"})])]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=LrcJP42NSmI"}},[_vm._v("Ver video ")])]),_vm._v(" "),_c('div',{staticClass:"zurda zurdas"},[_c('ul',{staticClass:"owl-carousel"},[_c('li',{staticClass:"slide slide1"},[_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/watch?v=LrcJP42NSmI"}},[_c('img',{staticClass:"cuarto-btn",attrs:{"src":__webpack_require__("vbKv"),"alt":""}})])]),_vm._v(" "),_c('li',{staticClass:"slide slide2"},[_c('img',{attrs:{"src":__webpack_require__("O6oy"),"alt":""}})])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"comercio"},[_c('h1',[_vm._v("Proceso Productivo y Comercial")]),_vm._v(" "),_c('div',{staticClass:"cont-1170"},[_c('img',{attrs:{"src":__webpack_require__("kmhf"),"alt":""}}),_vm._v(" "),_c('video',{attrs:{"controls":"","src":__webpack_require__("hB+3")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "avom":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.5977a7b.jpg";

/***/ }),

/***/ "bDnV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjcwM0Q5ODRFRThDMzExRUJBMjhCOTY3NEIxQTkwMzVFIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjcwM0Q5ODRGRThDMzExRUJBMjhCOTY3NEIxQTkwMzVFIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzAzRDk4NENFOEMzMTFFQkEyOEI5Njc0QjFBOTAzNUUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzAzRDk4NERFOEMzMTFFQkEyOEI5Njc0QjFBOTAzNUUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4ZN+bOAAABYUlEQVR42mL8//8/AzJg9JvPC6SSgdgDiLWBGMT/AsTXgHgnEM/5vynxI4oeZEOABkQCqQlALMaAG7wB4mKgQYtgAkxIBlQCqWUEDAABESBeCFTfgOISoEAAkL2egXQQBXTRckYG33mcQM4HIGZDkvwLxMxEGAIKC36Qd9LRDACBf0AcC8QLCBjCCMS5IEOCsEiyAvEuoFMTgXQ4EN/CY5A/yBBNHJJaYPduSlwFpDSAuAqIH0K9gAyUQYbw4TDkD9zjmxL/A3E71NUf0NTxgAz5hMMQZrREWAhNAvxo6r6yAImb0LhHBzehmv2AVCsQ6+Cw7C4LNH1Yo0n8AmJ7oAEOQDqDQAxtBqUTbqg/WdDCg4XIBCfIBAywr0BGNJoEsQYkAPV/YEKKxgYSk3wHUN9CbLk4AUj1A7EAHs2fgbgEaMAsrEUB1CBhIJUCLU9UkcqT20C8G4hnAQ14jawHIMAAyX9rEw1nqXoAAAAASUVORK5CYII="

/***/ }),

/***/ "bcWU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bePC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certificado-9001-2015.2a8b2d5.jpg";

/***/ }),

/***/ "biWA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.5977a7b.jpg";

/***/ }),

/***/ "cGSs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nuestrasPlantas'
});

/***/ }),

/***/ "cP7l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ccS1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "clah":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "crb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d/Lt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("8wsf"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Suppliers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-6"},[_c('p',{staticClass:"text-center"},[_vm._v("If you have questions related to browsing the Ariba Portal please access our "),_c('strong',[_vm._v("Help Center")]),_vm._v(". You will find it on the upper right corner of your account.")]),_vm._v(" "),_c('div',{staticClass:"bnt"},[_c('a',{attrs:{"target":"_blank","href":"https://service.ariba.com/Supplier.aw/125042059/aw?awh=r&awssk=Y4TW9pUw&dard=1&ancdc=1"}},[_vm._v("ACCESSS"),_c('br'),_vm._v(" ARIBA Network")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"static/pdf/MEGA - Manual Ariba Proveedores.pdf"}},[_vm._v("manual"),_c('br'),_vm._v("suppliers")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d7h+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.ef15083.jpg";

/***/ }),

/***/ "d8fb":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBBRUNFRTc1RUIzMTExRUJCODFEOEQ5QTY5MjQ1NDE1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBBRUNFRTc2RUIzMTExRUJCODFEOEQ5QTY5MjQ1NDE1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEFFQ0VFNzNFQjMxMTFFQkI4MUQ4RDlBNjkyNDU0MTUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEFFQ0VFNzRFQjMxMTFFQkI4MUQ4RDlBNjkyNDU0MTUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7Mif5iAAABFElEQVR42mL8//8/Awww+s0XB1I5QOwBxMpQ4ftAvBOIJ//flPgcrhamEagpHEjNBmJeBuzgKxCnAzUvhWsEagoAstczEAfCgJpXMzL4zhMCct6ADEGSbANiSyB2xKFZnAlIlKJpAoFDQFOdgPRlHBorQRoDsEjsADo/EqhZD8i+iEXeB6RRHoepy4Cac4CaDYDs02hyUkwEAoIVSv9DE2cEaXyEQ1M80LZ+oK2ngGxzNLlnII2bsPkBqGkRUNNZINsUi/w2UHSIABmv0SRagNgCiF1wuEYSlgBCgZxVRCaAaKBrloEDB5QSgFQMEH/Ho+EXECeCNKGkVWh6lQFSeUDsCo0mUMJ4CMR7oIn8IUwtQIABANQtWQtASYCZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "dL44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CabeceraEN__ = __webpack_require__("DPbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PieEN__ = __webpack_require__("LKlI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'regimen',
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_0__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_1__components_PieEN__["a" /* default */]
  }
});



__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).toggleClass('active');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.profile .box').toggleClass('open');
  });
});

/***/ }),

/***/ "dO+U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.5bd8532.jpg";

/***/ }),

/***/ "djE1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.5318e9f.png";

/***/ }),

/***/ "doJf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dwlz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Pie__ = __webpack_require__("iPQG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'regimen',
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_1__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_2__components_Pie__["a" /* default */]
  }
});



__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.profile .box').toggleClass('open');
  });
});

/***/ }),

/***/ "e8hY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eCCy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__ = __webpack_require__("g4dN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel__ = __webpack_require__("YiUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CabeceraEN__ = __webpack_require__("DPbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PieEN__ = __webpack_require__("LKlI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'quienesSomosEN',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.zurda > ul').owlCarousel({
      autoplay: true,
      items: 1,
      loop: true,
      slideSpeed: 1000,
      autoplaySpeed: 500,
      singleItem: true,
      dragBeforeAnimFinish: false,
      mouseDrag: true,
      touchDrag: true,
      nav: false
    });
  },
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_3__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_4__components_PieEN__["a" /* default */]
  }
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.primer-btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop').addClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.second-btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop1').addClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tercer-btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop2').addClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cuarto-btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop3').addClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop').removeClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop1').removeClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop2').removeClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop3').removeClass('act-pop');
  });
});

/***/ }),

/***/ "ePvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"id":"form-contactenos"}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.mensajeEstado),expression:"mensajeEstado"}],class:_vm.claseEstado,domProps:{"innerHTML":_vm._s(_vm.mensajeEstado)}}),_vm._v(" "),_c('p',[_vm._v("Dejanos tu consulta, te responderemos a la brevedad. ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nombre"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],attrs:{"placeholder":"Nombre y apellido","type":"text","name":"nombre"},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"tel"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tel),expression:"tel"}],attrs:{"placeholder":"Teléfono","type":"tel","name":"tel"},domProps:{"value":(_vm.tel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tel=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"placeholder":"Email","type":"mail","name":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"consulta"}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.consulta),expression:"consulta"}],attrs:{"placeholder":"Consulta","name":"consulta"},domProps:{"value":(_vm.consulta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.consulta=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"boton"},[_c('button',{attrs:{"type":"submit","name":"dsubmit","value":"Submit"},on:{"click":function($event){$event.preventDefault();return _vm.enviarFormulario($event)}}},[_vm._v("Enviar")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "evdj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"cabecera",attrs:{"id":"cabecera"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name: 'Home'}}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("7Otq"),"alt":"Mega Compañía - Logo"}})]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('nav',{staticClass:"nav-principal"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{name: 'quienesSomos'}}},[_vm._v("¿Quiénes Somos?")])],1),_vm._v(" "),_c('li',{staticClass:"js-btn-desp mb-none"},[_vm._v("Inversores "),_c('br',{staticClass:"hidden-md-down"}),_vm._v(" "),_c('ul',{staticClass:"desplegables"},[_c('li',[_c('router-link',{attrs:{"to":{name: 'regimen'}}},[_vm._v("Régimen de Oferta Pública")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'info'}}},[_vm._v("Información Financiera")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'gobierno'}}},[_vm._v("Gobierno Corporativo")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'contact'}}},[_vm._v("Contacto")])],1)])]),_vm._v(" "),_c('li',{staticClass:"mb-li"},[_c('router-link',{attrs:{"to":{name: 'regimen'}}},[_vm._v("Régimen de Oferta Pública")])],1),_vm._v(" "),_c('li',{staticClass:"mb-li"},[_c('router-link',{attrs:{"to":{name: 'info'}}},[_vm._v("Información Financiera")])],1),_vm._v(" "),_c('li',{staticClass:"mb-li"},[_c('router-link',{attrs:{"to":{name: 'gobierno'}}},[_vm._v("Gobierno Corporativo")])],1),_vm._v(" "),_c('li',{staticClass:"mb-li"},[_c('router-link',{attrs:{"to":{name: 'contact'}}},[_vm._v("Contacto")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'relacionesInstitucionales'}}},[_vm._v("Relaciones Institucionales")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'contactenos'}}},[_vm._v("Contactanos")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'proveedores'}}},[_vm._v("Proveedores")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'lineaEtica'}}},[_vm._v("Línea Ética")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Home'}}},[_vm._v("ESP")]),_vm._v(" |\n            "),_c('router-link',{attrs:{"to":{name: 'HomeEN'}}},[_vm._v("ENG")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"burger burger-efecto mostrar"},[_c('span',{staticClass:"burger-box"},[_c('span',{staticClass:"burger-inner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f2zm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nuestrosComienzos',
  data: function data() {
    return {
      msg: 'Nuestros comienzos'
    };
  }
});

/***/ }),

/***/ "fFwj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabecera'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pie')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("Kuwp"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Relaciones Institucionales")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("En Compañía Mega S.A. hemos trabajado desde el comienzo de las operaciones en construir un vínculo entre nuestra\nCompañía y los distintas partes interesadas de acuerdo con nuestro Manual de Gestión. De esta forma hemos desarrollado diferentes programas que nos han permitido acercarnos a la comunidad. Los públicos externos se componen, entre otros, de: clientes, proveedores, vecinos, superficiarios, entidades públicas y privadas, asociaciones civiles, ONG’s y medios de\ncomunicación.")]),_vm._v(" "),_c('h5',[_vm._v("Programa de Becas Acompañando a Crecer")]),_vm._v(" "),_c('p',[_vm._v("\nCompañía Mega S.A. desarrolla desde el año 2003 un programa de Becas Universitarias orientada a estudiantes egresados del sistema polimodal de Ingeniero White, mediante el cual se otorgan cinco becas anuales.\nEste programa se lleva a cabo con la colaboración de la Fundación Cecilia Grierson, quien acompaña en la evaluación de los postulantes y en el seguimiento de las becas otorgadas.")]),_vm._v(" "),_c('h6',[_vm._v("Los requisitos para la inscripción son:")]),_vm._v(" "),_c('ul',[_c('li',[_c('img',{attrs:{"src":__webpack_require__("zDh6"),"alt":""}}),_vm._v("Obtener titulo de estudio de polimodal en establecimientos de Ingeniero White")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("zDh6"),"alt":""}}),_vm._v("Realizar estudios universitarios en la ciudad de Bahía Blanca")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("zDh6"),"alt":""}}),_vm._v("Tener promedio general de calificaciones en el polimodal no inferior a 8 puntos")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("zDh6"),"alt":""}}),_vm._v("No poseer otras becas o pasantías")])]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/reglamento2021.docx"}},[_vm._v("VER REGLAMENTO DE BECAS")]),_vm._v(" "),_c('div',{staticClass:"cont-pdf"},[_c('img',{staticClass:"img",attrs:{"src":__webpack_require__("WxGP"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"video"},[_c('h1',[_vm._v("20 años Mega")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-12 col-md-10"},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("El 1 de Abril de 2021 cumplimos 20 años y para celebrarlo elegimos contar nuestra historia en la voz de sus protagonistas. Pasado, presente y futuro de la compañía en los testimonios de las personas que son parte de la historia y del presente de Mega. En 2001 comenzó nuestra operación y nuestro objetivo de agregarle valor a la energía para llevarla a diferentes partes del país, la región y el mundo. #20AñosMega #LaVozDeNuestraHistoria #AgregamosValorALaEnergía")])]),_vm._v(" "),_c('video',{attrs:{"controls":"","playsinline":"","src":__webpack_require__("j+H/")}})])]),_vm._v(" "),_c('div',{staticClass:"banda-azul"},[_c('div',{staticClass:"texto"},[_c('h1',[_vm._v("Seguí la actualidad y novedades de nuestra compañía en nuestras Redes")]),_vm._v(" "),_c('div',{staticClass:"rrss"},[_c('a',{attrs:{"target":"_blank","href":"https://ar.linkedin.com/company/ciamega"}},[_c('img',{attrs:{"src":__webpack_require__("OFxn"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.youtube.com/channel/UCJIz0KFkNtsea_iY-H2b2cQ"}},[_c('img',{attrs:{"src":__webpack_require__("98sY"),"alt":""}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g4dN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gkyY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nuestraEmpresa',
  data: function data() {
    return {
      msg: 'Hola Juan esta es nuestra empresa'
    };
  }
});

/***/ }),

/***/ "gn60":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.45bd214.jpg";

/***/ }),

/***/ "gr5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestrasPlantas_vue__ = __webpack_require__("COVM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b71a13b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestrasPlantas_vue__ = __webpack_require__("woyS");
function injectStyle (ssrContext) {
  __webpack_require__("GqkE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b71a13b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestrasPlantas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b71a13b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestrasPlantas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h3ft":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_esquemaDelProceso_en_vue__ = __webpack_require__("Ofkk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ddb351_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_esquemaDelProceso_en_vue__ = __webpack_require__("xxL/");
function injectStyle (ssrContext) {
  __webpack_require__("cP7l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58ddb351"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_esquemaDelProceso_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ddb351_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_esquemaDelProceso_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h6qm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("owUo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64edcc12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("ThYT");
function injectStyle (ssrContext) {
  __webpack_require__("bcWU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64edcc12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64edcc12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hB+3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video2.227b174.mp4";

/***/ }),

/***/ "hBfA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAfCAIAAAAA3/ihAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBGRjg4N0RDRTk2QTExRUI5RDMwRjZCNjgyNTc0RDREIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBGRjg4N0RERTk2QTExRUI5RDMwRjZCNjgyNTc0RDREIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEZGODg3REFFOTZBMTFFQjlEMzBGNkI2ODI1NzRENEQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEZGODg3REJFOTZBMTFFQjlEMzBGNkI2ODI1NzRENEQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7nQA9bAAABzUlEQVR42mJk8J3HQC/AxEBHMHwtY8EjVxdh4Kgr+eHrr441l07eek1Dy2ZlW6e6q0HYARZy6plrbz39RKtghNsEAYnOqjSMs6dvvyFzrz/5SEPLYvoOvv38E8Jeefj+on13KLeMEU+mZmNhMlERef/11/XHH2ieGn/9+XfsxisiDZIR4WZiZHj85uv//6Rb1hhl6Kwv9e/ff0ZGEDeu//D9l581ZPhn51hDjGNiYlx28O60bTfCbBSrQvX0FYUgMb366P2y+Wd+//1HgmX2OhLWmmJwrgA3G5AU5mW30RKHC155+D7HW3NyugVcRFqYq8BP28tY1rBg47eff4hNIC8/fEcN0r9A8udvFPfGOCgj2wQHatJ8iwptqVxccXOAAubMnTdbTj/+/usvslSwlQJpCYQYUL7gTNe6y0CGlBDXqV5fYDBCxDHDkFKfnbr1GmITEDx79w3OBoK///5T2bIzd94ic+88/0TDKoadFUU7MxMjDS1jYmTEwx1tFgxry4CZFDXhMQNJDjZmZEEJQU5kLg8nK5zNi8QmXIJsO/MEWArA6wtIRQosMHeeewpk/AelPYY9F58ha7n34jNEFlcJwjjaIh61DB8ACDAAepOoBN9zneQAAAAASUVORK5CYII="

/***/ }),

/***/ "hUk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lineaEtica_en_vue__ = __webpack_require__("2tUf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ea7937_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lineaEtica_en_vue__ = __webpack_require__("5y+8");
function injectStyle (ssrContext) {
  __webpack_require__("YsmI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46ea7937"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lineaEtica_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ea7937_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lineaEtica_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hUnK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "hYQ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hoSU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hz+A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"nuestrosComienzos"},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Nuestros Comienzos")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("El desafío comenzó hace tiempo cuando la sociedad integrada por YPF S.A., Petrobras y Dow Argentina decidió a mediados de 1997 concretar un proyecto que explotara integralmente el gas natural. Así, con la concreción del mismo, los componentes ricos del gas natural pasaron a constituir el insumo básico de la industria del plástico, permitiendo la expansión de dicha industria fundamental para el crecimiento de la economía argentina.\n          ")]),_vm._v(" "),_c('p',[_vm._v("La inversión total del proyecto fue de U$S 715 millones, formados aproximadamente por U$S 506 millones de “hard costs”(ingeniería, provisión de equipos y construcción) y U$S 209 millones de “soft costs” (costos pre-operativos y de desarrollo, costos financieros, impuestos y otros). La financiación provino de préstamos a través de obligaciones negociables y del aporte de los socios.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("TLci"),"alt":""}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iApg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_medioAmbiente_vue__ = __webpack_require__("Aw/8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4da20b46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_medioAmbiente_vue__ = __webpack_require__("ncsU");
function injectStyle (ssrContext) {
  __webpack_require__("uHCS")
  __webpack_require__("ww60")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4da20b46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_medioAmbiente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4da20b46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_medioAmbiente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iPQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pie_vue__ = __webpack_require__("SvJk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3eb5f4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pie_vue__ = __webpack_require__("6MAX");
function injectStyle (ssrContext) {
  __webpack_require__("VtoR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a3eb5f4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3eb5f4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ib2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Pie__ = __webpack_require__("iPQG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contact',
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_1__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_2__components_Pie__["a" /* default */]
  }
});



__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.profile .box').toggleClass('open');
  });
});

/***/ }),

/***/ "id2H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/planta.310aab7.jpg";

/***/ }),

/***/ "iszN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"organizacion"},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Organización")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_c('strong',[_vm._v("Compañía Mega S.A.")]),_vm._v(" cuenta con un grupo humano altamente calificado y con la experiencia necesaria para operar con excelencia en la gestión de cada uno de los procesos que conforman la empresa.")]),_vm._v(" "),_c('p',[_vm._v("Alineada con su Política de Gestión, la organización está orientada al desarrollo de sus actividades con eficiencia y calidad en cada una de sus áreas.")])])])])]),_vm._v(" "),_c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h2',[_vm._v("Áreas de la compañía")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("2bts"),"alt":"Organigrama"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j+H/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/20anios.16134a1.mp4";

/***/ }),

/***/ "j9oL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relacionesInstitucionales_vue__ = __webpack_require__("EFv3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_166b2528_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relacionesInstitucionales_vue__ = __webpack_require__("fFwj");
function injectStyle (ssrContext) {
  __webpack_require__("tSNN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-166b2528"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relacionesInstitucionales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_166b2528_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relacionesInstitucionales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jmEZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1c.6cd96d5.png";

/***/ }),

/***/ "k4Q7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Pie__ = __webpack_require__("iPQG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'proveedores',
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_1__components_Pie__["a" /* default */]
  }
});

/***/ }),

/***/ "kMpX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kQMb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.a28e083.jpg";

/***/ }),

/***/ "kfvk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_regimen_vue__ = __webpack_require__("dwlz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6327c16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_regimen_vue__ = __webpack_require__("+u0w");
function injectStyle (ssrContext) {
  __webpack_require__("hYQ/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a6327c16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_regimen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6327c16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_regimen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kmhf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.7574c91.png";

/***/ }),

/***/ "kqvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Enviar CV")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("Si desea formar parte del equipo de Compañía Mega S.A., por favor envíenos su C.V. a la siguiente dirección")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:megacomunicaciones@ciamega.com.ar"}},[_vm._v("megacomunicaciones@ciamega.com.ar")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kzQl":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjZBNTIzNkU5RThDMzExRUJCNEFBRTIwODNEQzI3NTYzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjZBNTIzNkVBRThDMzExRUJCNEFBRTIwODNEQzI3NTYzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NkE1MjM2RTdFOEMzMTFFQkI0QUFFMjA4M0RDMjc1NjMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NkE1MjM2RThFOEMzMTFFQkI0QUFFMjA4M0RDMjc1NjMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz59GRqgAAABD0lEQVR42mJk8J2nxcDAsACIlYF40f9NiYUMJAAmIG4BYlMgFgLiAka/+bKkGrAOiX8HiN+TYgDj////GYC2cgLZikDnX2MgETACw0AeSEsB8Tcg5gMachhooASQ7QjE/4H4HVBsF1DMHsj2BuKfQLwFKHYSZAALEAcCcT+KoQwMFkC8DMp/C9Q8B0iXI6mpAYrlAA2ZCgqDL0gSL6H0dyQxYajm32iunwI0xIAJ6kwY+Aul/6MpbgJiESB2AuI/SOKRLESEEygM6qHs/UBbjwJpeyhfnIkIAz6j8d8isf8RYwC6K9lINYBgSuRA4gtBaVYsYjDAh8TmYYH6EebP50jRCBN7hmbASyS5NwABBgCErkkQlSbFfQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "lORO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lao+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CabeceraEN__ = __webpack_require__("DPbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PieEN__ = __webpack_require__("LKlI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'relacionesInstitucionales',
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_0__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_1__components_PieEN__["a" /* default */]
  }
});



/***/ }),

/***/ "lkvx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sistemaDeGestion'
});

/***/ }),

/***/ "lyqC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormContactenosEN',
  data: function data() {
    return {
      nombre: '',
      tel: '',
      email: '',
      consulta: '',
      estado: '',
      mensajeEstado: ''
    };
  },


  computed: {
    claseEstado: function claseEstado() {
      return 'alert alert-' + this.estado;
    }
  },

  methods: {
    enviarFormulario: function enviarFormulario(evento) {
      var _this = this;

      this.$http.get('http://synapsis.com.ar/test/formulario/mega.php', {
        params: {
          token: 'DrKrxX0Gjl243B38QDjg4EgppGDNh8vl',
          SenderName: this.nombre,
          tel: this.tel,
          SenderAddress: this.email,
          consulta: this.consulta
        },
        before: function before(request) {
          this.estado = 'info';
          this.mensajeEstado = 'Enviando...';
        }
      }).then(function (response) {
        if (response.body.error !== 'false') {
          _this.estado = 'success';
          _this.mensajeEstado = response.body.mensaje;

          // Borro los datos del form
          _this.nombre = '';
          _this.tel = '';
          _this.email = '';
          _this.consulta = '';
        } else {
          _this.estado = 'danger';
          _this.mensajeEstado = response.body.mensaje;
        }
      }, function (response) {
        _this.estado = 'danger';
        _this.mensajeEstado = response.body.mensaje;
      });
    }
  }
});

/***/ }),

/***/ "m2mK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('span',{attrs:{"id":"sistema-de-gestion"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("GB09"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("We have made a firm commitment to sustainable development")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cont-1300"},[_c('div',{staticClass:"right"},[_c('img',{attrs:{"src":__webpack_require__("Hr6n"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"left"},[_c('h2',[_vm._v("\n         Environment, Energy, Health and Safety\n        ")]),_vm._v(" "),_c('div',{staticClass:"zurda zurdas"},[_c('ul',{staticClass:"owl-carousel"},[_c('li',{staticClass:"slide slide1"},[_c('p',[_vm._v("\n                  Our Integrated Management System complies with ISO standards for quality, occupational health\nand safety, environmental and energy management."),_c('br'),_c('br'),_vm._v("\n                  At Compañía Mega S.A. we have framed a Management Policy based on 4 ethical principles:\nRespect, Integrity, Transparency and Safety. We are guided by these fundamental Values, which are\nalso part of our Vision."),_c('br'),_c('br'),_vm._v("\n\n                  The Management Policy formulated by our Management Team includes decisive actions to achieve continuous improvement in all these aspects\n                  ")])]),_vm._v(" "),_c('li',{staticClass:"slide slide2"},[_c('p',[_vm._v("\n                     These actions reaffirm the Company’s commitment to environmental compliance prioritizing\nprevention over mitigation and collaborating with different stakeholders in the search for\nenvironmentally friendly solutions while engaging contractors through the enforcement of\nenvironmental criteria and the implementation of measures and technologies aimed at enhancing\nenvironmentally friendly practices.\n                    ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"acciones"},[_c('div',{staticClass:"cont-1170"},[_c('h2',[_vm._v("Specific actions to achieve eco-efficiency")]),_vm._v(" "),_c('div',{staticClass:"mod"},[_c('ul',[_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" \n              Waste management and recycling\n            ")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Use of sophisticated technologies in the design of gas flares to control and reduce fuel gas emissions.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Conduction of studies on air quality and gas emissions.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Use of residual nitrogen as sweep gas to reduce fuel gas consumption.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Reduction in special waste.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Use of dedicated BOG compressor to minimize energy consumption.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Addition of a turbine to utilize available pressure drop.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Afforestation of industrial sites and local sewage treatment.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Purchase of laboratory equipment to enhance monitoring and production capabilities.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Conduction of technical/economic feasibility studies on the use of turbine exhaust gases.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Reduction in the amount of smoke released into the atmosphere.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("L+Nk"),"alt":""}}),_vm._v(" Treatment of CO 2 stream.")])])]),_vm._v(" "),_c('video',{attrs:{"controls":"","src":__webpack_require__("oXTu")}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"acciones"},[_c('div',{staticClass:"cont-1170"},[_c('h2',[_vm._v("Integrated Management System")]),_vm._v(" "),_c('div',{staticClass:"mod"},[_c('p',[_vm._v("On November 1, 2002, Compañía Mega S.A. implemented an Integrated Management System (IMS).\nThis system has been gradually and substantially strengthened through multiple external\nmaintenance and recertification audits conducted by International accredited Certifying Agencies. At\npresent, Compañía Mega S.A. complies with the requirements of the following ISO standards: ISO\n9001:2015 (Quality Management System), ISO 45001:2018 (Occupational Health and Safety\nManagement System), ISO 14001:2015 (Environmental Management System) and ISO\n50001:2018 (Energy Management System) in the separation, transportation, and storage of the\nliquid components of natural gas and the sale and shipment of its products."),_c('br'),_c('br'),_vm._v("\n\n        At Compañía Mega we have risen to the challenge of implementing and keeping an Integrated\nManagement System based on four ISO standards. In order to comply with these 4 standards, we\nmust consider and assess multiple locations, contexts, cultures, and operating processes. Therefore,\nprocess standardization and optimization and continuous improvement are an inherent part of our\nculture.")])]),_vm._v(" "),_c('div',{staticClass:"caja"},[_c('a',{attrs:{"href":"static/pdf/COMPAÑIA%20MEGA%20S.A.%20(OAA%209001-2015)%20CERTIFICATE%20AR-O240585%20v01.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("OjGd"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/COMPAÑIA MEGA S.A. (OAA 14001-2015) CERTIFICATE AR-O240586 v01.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("N1q+"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/COMPAÑIA MEGA S.A. (UKAS 45001-2018) CERTIFICATE AR-U240587 v01.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("2QV4"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/Certificado 50001-2018.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("UcMC"),"alt":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"accionest acciones"},[_c('div',{staticClass:"cont-1170"},[_c('h2',[_vm._v("Management Policy")]),_vm._v(" "),_c('img',{staticClass:"imgs",attrs:{"src":__webpack_require__("mBW+"),"alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mBW+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.a9934d0.png";

/***/ }),

/***/ "n//S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CabeceraEN__ = __webpack_require__("DPbz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'enviarCV',
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_0__components_CabeceraEN__["a" /* default */]
  }
});


/***/ }),

/***/ "n5hO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.3505873.jpg";

/***/ }),

/***/ "nHuZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certificado-14001-2015.4656c66.jpg";

/***/ }),

/***/ "nM/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contactenos_vue__ = __webpack_require__("3kaA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1650a637_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contactenos_vue__ = __webpack_require__("4aQj");
function injectStyle (ssrContext) {
  __webpack_require__("p/DZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1650a637"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contactenos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1650a637_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contactenos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ncsU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabecera'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('span',{attrs:{"id":"sistema-de-gestion"}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('pie')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("zsly"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Comprometidos con un "),_c('br'),_vm._v("desarrollo sostenible")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cont-1300"},[_c('div',{staticClass:"right"},[_c('img',{attrs:{"src":__webpack_require__("gn60"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"left"},[_c('h2',[_vm._v("\n       Medio Ambiente y Seguridad\n      ")]),_vm._v(" "),_c('div',{staticClass:"zurda zurdas"},[_c('ul',{staticClass:"owl-carousel"},[_c('li',{staticClass:"slide slide1"},[_c('p',[_vm._v("\n            Nuestro Sistema de Gestión Integrado está integrado por la familia de normas ISO referidas a sistemas de calidad, seguridad y salud ocupacional, ambiente y de gestión de la energía."),_c('br'),_c('br'),_vm._v("\n            En "),_c('strong',[_vm._v("Compañía Mega S.A.")]),_vm._v(" hemos definimos la Política de Gestión la cual está fundada sobre los 4 pilares éticos de la organización "),_c('strong',[_vm._v("(Respeto, Integridad, Transparencia y Seguridad)")]),_vm._v(" desde aquí se desprenden nuestros "),_c('strong',[_vm._v("Valores")]),_vm._v(" que están comprendidos dentro de la "),_c('strong',[_vm._v("Visión")]),_vm._v(" de la misma."),_c('br'),_c('br'),_vm._v("\n\n            El Equipo de Dirección ha establecido una serie de acciones\n            concretas relacionadas con el desarrollo eco-eficiente,\n            enunciados dentro de la Política de Gestión. \n            ")])]),_vm._v(" "),_c('li',{staticClass:"slide slide2"},[_c('p',[_vm._v("\n                A través de estas acciones la Compañía asume un compromiso en el cumplimiento de la legislación y las reglamentaciones\n                ambientales, priorizando la prevención de impactos ambientales antes que la corrección de los mismos, colaborando con las\n                distintas partes interesadas en la búsqueda de soluciones a los problemas relacionados con el medioambiente; asimismo\n                involucramos a nuestros contratistas mediante el cumplimiento de criterios ambientales, teniendo en cuenta las medidas o\n                tecnologías que pudieran ser aplicadas a fin de generar una mejora significativa en aspectos relacionados con el\n                medioambiente.\n              ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cont-1300 cont-premio"},[_c('div',{staticClass:"right"},[_c('h2',[_vm._v("Premios")]),_vm._v(" "),_c('div',{staticClass:"zurda zurdas"},[_c('p',[_c('a',{attrs:{"href":"https://www.linkedin.com/company/ciamega/","targeg":"_blank"}},[_vm._v("COMPAÑÍA MEGA")]),_vm._v(" recibió el “"),_c('strong',[_vm._v("Premio Anual a la Seguridad")]),_vm._v("” del IAPG "),_c('strong',[_vm._v("en los rubros empresas Refinadores/Comercializadoras y Distribuidoras")]),_vm._v(". Este premio reconoce a aquellas compañías que lograron la más destacada actuación en materia de seguridad. "),_c('br'),_c('br'),_vm._v("Este reconocimiento nos llena de orgullo ya que refuerza firmemente la cultura de nuestra Política de gestión; impulsar la seguridad y la integridad, junto con la calidad, la eficiencia y el respeto por el medio ambiente, que son los pilares fundamentales del desempeño global del negocio, de la relaciones con los clientes y con nuestro grupo de interés. "),_c('br'),_c('br'),_vm._v("También hemos sido reconocidos por el CEM ("),_c('a',{attrs:{"href":"https://www.linkedin.com/company/clean-energy-ministerial/","target":"_blank"}},[_vm._v("Clean Energy Ministerial")]),_vm._v(") por nuestra labor en materia de Eficiencia Energética; fuimos galardonados con el Premio 2021 Energy Management Insight Award."),_c('br'),_c('br'),_vm._v("Este reconocimiento refleja nuestro desarrollo en materia de Eficiencia Energética y los beneficios obtenidos por la implementación de la norma ISO 50001. Es un gran honor ser reconocidos entre destacadas compañías internacionales, ya que consideramos que el reconocimiento otorgado nos desafía a continuar por este camino y refuerza el compromiso de nuestra organización con el uso eficiente de la energía y la sustentabilidad de los recursos.")])])]),_vm._v(" "),_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":__webpack_require__("BSnh"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"acciones"},[_c('div',{staticClass:"cont-1170"},[_c('h2',[_vm._v("Acciones concretas de desarrollo eco-eficiente")]),_vm._v(" "),_c('div',{staticClass:"mod"},[_c('ul',[_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" \n            Reciclado de residuos.\n          ")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Cambio de tecnología de diseño en antorchas de gases para el menor consumo de gas combustible y en control de emisiones.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Estudios de calidad de aire y emisiones gaseosas.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Aprovechamiento de nitrógeno residual como gas de sweeping para disminuir el consumo de gas combustible.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Disminución de la generación de residuos especiales.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Incorporación de equipamiento específico en compresor BOG para reducir consumo de energía eléctrica.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Incorporación de turbina para aprovechamiento de salto de presión.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Forestación dentro del predio industrial aprovechando el tratamiento de efluentes cloacales.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Adquisición de equipamiento de laboratorio que nos permite eficientizar el monitoreo y procesos productivos.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Estudios de factibilidad técnico/económica de aprovechamiento de gases de escape de turbinas.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Reducción de emisión de humo a la atmósfera.")]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("d8fb"),"alt":""}}),_vm._v(" Tratamiento de la corriente de anhídrido carbónico.")])])]),_vm._v(" "),_c('video',{attrs:{"controls":"","src":__webpack_require__("LzmR")}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"acciones"},[_c('div',{staticClass:"cont-1170"},[_c('h2',[_vm._v("Sistema de Gestión Integrado")]),_vm._v(" "),_c('div',{staticClass:"mod"},[_c('p',[_c('strong',[_vm._v("Compañía Mega S.A.")]),_vm._v(", implementó un Sistema de Gestión Integrado desde el 1 de noviembre de 2002 y a través de las auditorías\n      externas de mantenimiento y de recertificación por parte del Ente Certificador Internacional se va robusteciendo y consolidando vez tras vez nuestro sistema. Hoy acreditamos el cumplimiento de los requisitos de las normas "),_c('strong',[_vm._v("ISO 9001:2015")]),_vm._v(" (Sistemas de Gestión de la Calidad), "),_c('strong',[_vm._v("ISO 45001:2018")]),_vm._v(" (Sistemas de Gestión de la Seguridad y Salud en el Trabajo), "),_c('strong',[_vm._v("ISO 14001:2015")]),_vm._v(" (Sistemas de Gestión Ambiental) e "),_c('strong',[_vm._v("ISO 50001:2018")]),_vm._v(" (Sistemas de Gestión de la Energía), las cuales son aplicables al proceso de separación, transporte, fraccionamiento y almacenamiento de los componentes líquidos del gas natural, despacho y venta de productos."),_c('br'),_c('br'),_vm._v("\n\n      La implementación y mantenimiento del Sistema de Gestión Integrado basado en las Normas ISO (sistema certificado de tetranormas) resulta de gran desafío para la Compañía, teniendo en cuenta las diferentes localizaciones, contextos, culturas y procesos operativos. Esto significa que la estandarización, la optimización de los procesos y la mejora continua es parte de la genética y de los estándares\n      de la Compañía.")])]),_vm._v(" "),_c('div',{staticClass:"caja"},[_c('a',{attrs:{"href":"static/pdf/COMPAÑIA%20MEGA%20S.A.%20(OAA%209001-2015)%20CERTIFICATE%20AR-O240585%20v01.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("jmEZ"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/COMPAÑIA MEGA S.A. (OAA 14001-2015) CERTIFICATE AR-O240586 v01.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("DQ1w"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/COMPAÑIA MEGA S.A. (UKAS 45001-2018) CERTIFICATE AR-U240587 v01.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("rjI0"),"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"static/pdf/Certificado 50001-2018.pdf","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("L5JE"),"alt":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"accionest acciones"},[_c('div',{staticClass:"cont-1170"},[_c('h2',[_vm._v("Política y Principios de Gestión")]),_vm._v(" "),_c('img',{staticClass:"imgs",attrs:{"src":__webpack_require__("CSdQ"),"alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o3KE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/linea-etica.a90051c.jpg";

/***/ }),

/***/ "o9L2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oXTu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video.86d53dd.mp4";

/***/ }),

/***/ "owUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__ = __webpack_require__("g4dN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel__ = __webpack_require__("YiUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pie__ = __webpack_require__("iPQG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.slider-principal > ul').owlCarousel({
      autoplay: true,
      items: 1,
      loop: true,
      slideSpeed: 1000,
      autoplaySpeed: 500,
      singleItem: true,
      dragBeforeAnimFinish: false,
      mouseDrag: true,
      touchDrag: true,
      nav: false
    });
  },
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_3__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_4__components_Pie__["a" /* default */]
  }
});

/***/ }),

/***/ "p/DZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p6f9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'enviarCV'
});

/***/ }),

/***/ "pD7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contactenos_en_vue__ = __webpack_require__("y8bm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0bc2eac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contactenos_en_vue__ = __webpack_require__("8b4N");
function injectStyle (ssrContext) {
  __webpack_require__("yqMp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c0bc2eac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contactenos_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0bc2eac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contactenos_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pbD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"id":"form-contactenos"}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.mensajeEstado),expression:"mensajeEstado"}],class:_vm.claseEstado,domProps:{"innerHTML":_vm._s(_vm.mensajeEstado)}}),_vm._v(" "),_c('p',[_vm._v("Send us your questions. We will respond shortly. ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nombre"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],attrs:{"placeholder":"Name","type":"text","name":"nombre"},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"tel"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tel),expression:"tel"}],attrs:{"placeholder":"Telephone","type":"tel","name":"tel"},domProps:{"value":(_vm.tel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tel=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"placeholder":"Email","type":"mail","name":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"consulta"}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.consulta),expression:"consulta"}],attrs:{"placeholder":"Comments","name":"consulta"},domProps:{"value":(_vm.consulta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.consulta=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"boton"},[_c('button',{attrs:{"type":"submit","name":"dsubmit","value":"Submit"},on:{"click":function($event){$event.preventDefault();return _vm.enviarFormulario($event)}}},[_vm._v("Send")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qJL8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.dae0b15.jpg";

/***/ }),

/***/ "qfzM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qzI3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r2Oj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.5977a7b.jpg";

/***/ }),

/***/ "rjI0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3c.3148ce0.png";

/***/ }),

/***/ "rp8O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sDsX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sIId":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quienesSomos_en_vue__ = __webpack_require__("eCCy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f45acdd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quienesSomos_en_vue__ = __webpack_require__("9jRN");
function injectStyle (ssrContext) {
  __webpack_require__("6rzM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f45acdd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quienesSomos_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f45acdd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quienesSomos_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t7D0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.ef15083.jpg";

/***/ }),

/***/ "tSNN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tUJ8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tYMN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.d7c3233.png";

/***/ }),

/***/ "tZhy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organizacion_en_vue__ = __webpack_require__("V2ZW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e338ade_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Organizacion_en_vue__ = __webpack_require__("R43U");
function injectStyle (ssrContext) {
  __webpack_require__("qzI3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e338ade"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organizacion_en_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e338ade_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Organizacion_en_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "twXY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/g-premio.9522114.jpg";

/***/ }),

/***/ "u8GJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Nuestra Empresa")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-3"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("9ICL"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-12 col-md-5"},[_c('p',[_c('strong',[_vm._v("Compañía Mega")]),_vm._v(" opera desde principios del año 2001 y tiene como visión y misión:"),_c('br'),_vm._v("\n            Ser el protagonista esencial en el procesamiento de gas de la cuenca neuquina y en el desarrollo de infraestructura energética en la región, impulsando el crecimiento de la producción de gas y potenciando a la industria petroquímica.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Contribuir al desarrollo energético del país y al desarrollo del sector petroquímico.")])]),_vm._v(" "),_c('p',[_vm._v("El eje principal de su negocio es agregar valor al gas natural a través de la separación y fraccionamiento de sus componentes ricos, a fin de recuperar etano que constituye la principal materia prima de la industria petroquímica argentina y exportar los componentes líquidos hacia otros mercados.")])])])])]),_vm._v(" "),_c('section',{staticClass:"secundario"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('h2',[_vm._v("Productos")]),_vm._v(" "),_c('p',[_vm._v("La separación de los componentes líquidos del gas natural y su fraccionamiento permite obtener como productos principales etano, propano, butano y gasolina natural. El etano constituye la materia prima básica del complejo Petroquímico de Bahía Blanca, a partir del cual se obtiene etileno para elaboración de polietilenos y PVC.")]),_vm._v(" "),_c('p',[_vm._v("La producción de propano, butano y gasolina natural se despachan vía marítima a Petrobras: el propano y el butano tienen como destino el abastecimiento de los centros de consumo, mientras que la gasolina natural se utiliza mayoritariamente como materia prima en la industria petroquímica para la producción de etileno, propileno y butadieno.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("2akJ"),"alt":"Banner de las plantas de Mega Cia."}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uHCS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uR1W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.f403d87.jpg";

/***/ }),

/***/ "vPma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cabeceraEN'
});

// $(document).ready(function () {
//   $('.desplegable').hide()
//   $('.nav-principal .js-btn-desp').click(function (event) {
//     var desplegable = $(this).children('.desplegable')
//     $('.desplegable').not(desplegable).slideUp('fast')
//     desplegable.slideToggle('fast')
//     // event.preventDefault()
//   })
// })
// Menú hamburguesa //
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.burger').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('is-active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('header').toggleClass('activo');
  });
});

/***/ }),

/***/ "vbKv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.1f131e0.jpg";

/***/ }),

/***/ "w+3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Ariba")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"caja"},[_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"href":"https://service.ariba.com/Supplier.aw/124996083/aw?awh=r&awssk=C56809bX&dard=1"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("Acceso a ARIBA Network")])])]),_vm._v(" "),_c('div',{staticClass:"btn-ar"},[_c('a',{attrs:{"href":"static/pdf/MEGA - Manual Ariba Proveedores.pdf"}},[_c('i',{staticClass:"icon-file-pdf"}),_c('h5',[_vm._v("Manual de proveedores")])])]),_vm._v(" "),_c('p',[_vm._v("En caso de dudas de navegación del portal Ariba, por favor, acceda a nuestro Centro de Ayuda ubicado en la esquina superior derecha de su cuenta.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w6jg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w7kl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.5977a7b.jpg";

/***/ }),

/***/ "wSQa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/esquema.0214b24.png";

/***/ }),

/***/ "wXvF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.bb01749.png";

/***/ }),

/***/ "wcyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('cabeceraEN'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pieEN')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cabecera"},[_c('img',{attrs:{"src":__webpack_require__("biWA"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Contact")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"caja"},[_c('h2',[_vm._v("Investor Relations")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("José Luis Borrello")]),_c('br'),_vm._v("\n            Finance and Stategic Planning Manager"),_c('br'),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"mailto:inversores@ciamega.com.ar "}},[_vm._v("inversores@ciamega.com.ar ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wmBQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "woyS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Nuestras Plantas")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("La ubicación geográfica de las instalaciones es otra característica particular de nuestra compañía dado que el proceso se divide en dos instalaciones: una planta separadora y una planta fraccionadora, conectadas por un ducto de 600 km de longitud que atraviesa cuatro provincias.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("La Planta Separadora")]),_vm._v(" está ubicada en el corazón del yacimiento de gas natural argentino, "),_c('strong',[_vm._v("Loma La Lata")]),_vm._v(", provincia del Neuquén. Se abastece por una corriente de gas natural de aproximadamente 40 millones de metros cúbicos estándar por día para alimentar el proceso en el que se retienen líquidos por el equivalente de aproximadamente 5 millones de metros cúbicos por día, retornando el \"gas seco\" o metano a YPF S.A. que lo inyecta en los sistemas troncales de transporte de gas natural (NEUBA II, CENTRO OESTE Y PACIFICO). Los líquidos retenidos son transportados por un poliducto de 12 pulgadas de diámetro, a través de 600 kilómetros que separan Neuquén de Bahía Blanca, donde se ubica la Planta Fraccionadora.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("La Planta Fraccionadora")]),_vm._v(" se ubica dentro del Polo Petroquímico de "),_c('strong',[_vm._v("Bahía Blanca")]),_vm._v("; el más grande del país, aprovechando así la infraestructura de un complejo industrial integrado, un puerto de aguas profundas y la escasa distancia que separa a la planta de su consumidor de etano. En la planta se fraccionan los líquidos, obteniéndose etano, propano, butano y gasolina natural. Además, presenta instalaciones especialmente construidas para el almacenamiento y despacho de propano, butano y gasolina natural.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Compañía Mega S.A.")]),_vm._v(" cuenta con la ventaja competitiva de tener un extraordinario muelle ubicado sobre el canal de Acceso del Complejo Portuario de Bahía Blanca, único puerto de aguas profundas del país, que permite la exportación de productos en buques de gran porte.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("RJFY"),"alt":"Planta"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wq+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quienesSomos_vue__ = __webpack_require__("zDiD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a44653c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quienesSomos_vue__ = __webpack_require__("ahZb");
function injectStyle (ssrContext) {
  __webpack_require__("8/3X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a44653c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quienesSomos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a44653c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quienesSomos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ww60":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xGDn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__ = __webpack_require__("g4dN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel__ = __webpack_require__("YiUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PieEN__ = __webpack_require__("LKlI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CabeceraEN__ = __webpack_require__("DPbz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'medioAmbienteEN',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.zurda > ul').owlCarousel({
      autoplay: false,
      items: 1,
      loop: true,
      slideSpeed: 1000,
      autoplaySpeed: 500,
      singleItem: true,
      dragBeforeAnimFinish: false,
      mouseDrag: true,
      touchDrag: true,
      nav: true,
      dots: false
    });
  },
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_4__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_3__components_PieEN__["a" /* default */]
  }
});



/***/ }),

/***/ "xITy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/20.de791a9.png";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Pie__ = __webpack_require__("iPQG");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      empresa: {
        ba: {
          prov: 'BUENOS AIRES',
          calle: 'San Martín 344, piso 27º',
          cp: '(C1004AAH)',
          ciudad: 'Ciudad Autónoma de Buenos Aires',
          tel1: '(54 11) 2821-0300'
          // tel2: '(54-11) 5441-5746',
          // tel2Short: '5746',
          // fax1: '(54-11) 4032-0096'
          // fax2: '(54-11) 5441-5731',
          // fax2Short: '5731'
        },
        nqn: {
          prov: 'PLANTA NEUQUEN',
          calle: 'Ruta Provincial 51, km 85',
          cp: '(Q8300XAD) Loma La Lata',
          ciudad: 'Provincia de Neuquén',
          tel1: '(54 299) 490-4-400'
          // tel2: '(54-299) 489-3938',
          // tel2Short: '8',
          // fax1: '(54-299) 489-3937 int 1019'
        },
        bahia: {
          prov: 'PLANTA BAHIA BLANCA',
          calle: 'Av. del Desarrollo Presidente Frondizi s/n',
          cp: '(B8000XAU) Puerto Galván',
          ciudad: 'Provincia de Buenos Aires',
          tel1: '(54 291) 403-7-650'
          // tel2: '(54-11) 5441-5746',
          // fax1: '(54-291) 457-2471'
        }
      }
    };
  },
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_1__components_Pie__["a" /* default */]
  }
});

/***/ }),

/***/ "xorr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xxL/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{},[_c('section',{staticClass:"portada"},[_c('div',{staticClass:"linea"},[_c('h1',[_vm._v("Esquema del proceso")])])]),_vm._v(" "),_c('section',{staticClass:"lineas"},[_c('div',{staticClass:"linea1"}),_vm._v(" "),_c('div',{staticClass:"linea2"}),_vm._v(" "),_c('div',{staticClass:"linea3"})]),_vm._v(" "),_c('section',{staticClass:"descripcion"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8"},[_c('p',[_vm._v("El  proceso se divide en dos instalaciones principales: una Planta Separadora y una Planta Fraccionadora, conectadas por un ducto de 600km con una estación de bombeo intermedia, que atraviesa cuatro provincias")]),_vm._v(" "),_c('img',{staticClass:"img-fluid img-esq",attrs:{"src":__webpack_require__("+BjY"),"alt":"Esquema del proceso de Mega"}}),_vm._v(" "),_c('h4',[_vm._v("PLANTA SEPARADORA LOMA LA LATA")]),_vm._v(" "),_c('p',[_vm._v("Ubicada en el corazón del yacimiento de gas natural argentino, Loma La Lata, provincia de Neuquén.")]),_vm._v(" "),_c('h6',[_vm._v("Separación del gas de entrada:")]),_vm._v(" "),_c('p',[_vm._v("El gas que ingresa a la planta es enviado a un separador de alimentación a fin de eliminar cualquier partícula extraña previo a su envío al sector de deshidratación.")]),_vm._v(" "),_c('h6',[_vm._v("Deshidratación:")]),_vm._v(" "),_c('p',[_vm._v("Para separar los componentes ricos, la corriente del gas natural que entra a la Planta Separadora se somete a un proceso de enfriamiento. Sin embargo, para poder realizar este proceso, es condición precedente quitarle al gas el agua que trae consigo. La etapa de deshidratación deja al gas con un contenido de agua menor a una parte por millón. El sistema de deshidratación consta de cinco lechos: cuatro operativos y uno de regeneración.")]),_vm._v(" "),_c('h6',[_vm._v("Recuperación:")]),_vm._v(" "),_c('p',[_vm._v("El gas deshidratado se divide en dos corrientes para ingresar cada una a un tren de separación criogénica. El proceso consiste en una expansión hasta los 26Kg/cm2, disminuyendo la temperatura del gas hasta los -97°C. En estas condiciones ingresa a la torre demetanizadora, separando al gas natural en sus diferentes componentes. De esta manera el etano, propano, butano y gasolina natural se condensan y son recogidos en estado líquido por el fondo de la torre (NGL). El metano residual, todavía en estado gaseoso, es recuperado por el tope de la torre para su acondicionamiento e inyección a gasoductos. El sistema de separación permite una eficiencia de hasta 88% en la recuperación de etano y superior a 96% en la recuperación de propano.")]),_vm._v(" "),_c('h6',[_vm._v("Estación de compresión de gas:")]),_vm._v(" "),_c('p',[_vm._v("El gas residual obtenido de la demetanización, mayoritariamente metano, es recomprimido a fin de inyectarlo al gasoducto. Para este fin la planta cuenta con un sistema de compresión de 93000hp que descarga a un cabezal desde donde se alimentan los principales gasoductos troncales del país.")]),_vm._v(" "),_c('h4',[_vm._v("POLIDUCTO")]),_vm._v(" "),_c('p',[_vm._v("El objetivo del poliducto es el de transportar el líquido recuperado (que mayoritariamente es etano, propano, butano y gasolina natural) desde la planta de Loma La Lata hasta la planta de Bahía Blanca.")]),_vm._v(" "),_c('h4',[_vm._v("PLANTA FRACCIONADORA DE BAHÍA BLANCA")]),_vm._v(" "),_c('p',[_vm._v("En la planta se recibe el líquido recuperado en Loma La Lata y transportado a través de 600 km de ducto, y se fracciona el etano, propano, butano y gasolina natural mediante procesos de destilación (deetanización, depropanización y debutanización).")]),_vm._v(" "),_c('h6',[_vm._v("Deetanización, Depropanización y Debutanización:")]),_vm._v(" "),_c('p',[_vm._v("El líquido recuperado en Loma La Lata que ingresa a este sector de destilación debe ser precalentado para garantizar una temperatura constante de alimentación a la deetanizadora. Este precalentamiento se lleva a cabo intercambiando calor con gasolina natural, que a su vez es pre-enfriada antes de su almacenamiento. Durante la deetanización se separa el etano del líquido formado por propano, butano y gasolina natural, para su posterior tratamiento. Esta mezcla líquida es acondicionada para llevar a cabo la depropanización en la que se obtiene el propano y una mezcla líquida constituida por butano y gasolina natural que nuevamente es acondicionada para ingresar a la columna de destilación donde se realiza la debutanización. En esta columna de destilación se obtienen el butano y la gasolina natural. Tanto el propano como el butano y la gasolina natural son acondicionados térmicamente para su almacenamiento.")]),_vm._v(" "),_c('h6',[_vm._v("Tratamiento de etano:")]),_vm._v(" "),_c('p',[_vm._v("El sector de tratamiento de etano consiste en una unidad de remoción de dióxido de carbono. La remoción del dióxido de carbono se basa en una tecnología con aminas que deja el etano prácticamente libre de dióxido de carbono. El anhídrido carbónico se acondiciona en una etapa posterior para eliminar el ácido sulfhídrico y se comercializa parcialmente.")]),_vm._v(" "),_c('h6',[_vm._v("Sistema de refrigeración de productos:")]),_vm._v(" "),_c('p',[_vm._v("El sistema de refrigeración de productos proporciona el frío requerido para el almacenamiento de propano, butano, gasolina natural y la condensación de la deetanización.")]),_vm._v(" "),_c('h6',[_vm._v("Almacenamiento de productos:")]),_vm._v(" "),_c('p',[_vm._v("El sector de almacenamiento está compuesto por tanques de propano, butano y gasolina natural. Todos los productos se almacenan a presión atmosférica. La gasolina natural se almacena en tanques de techo flotante, mientras que el propano y el butano se almacenan en tanques refrigerados.")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("Xe9c"),"alt":"Planta de Mega Cia"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y8bm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contactenos_en_form_contactenos_en__ = __webpack_require__("JPVK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CabeceraEN__ = __webpack_require__("DPbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PieEN__ = __webpack_require__("LKlI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contactenosEN',
  components: {
    FormContactenosEN: __WEBPACK_IMPORTED_MODULE_0__components_contactenos_en_form_contactenos_en__["a" /* default */],
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_1__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_2__components_PieEN__["a" /* default */]
  }
});



/***/ }),

/***/ "yhq2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.1b115b6.png";

/***/ }),

/***/ "yqMp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ywzX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestrosComienzos_vue__ = __webpack_require__("6sux");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc0a7558_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestrosComienzos_vue__ = __webpack_require__("hz+A");
function injectStyle (ssrContext) {
  __webpack_require__("MINx")
  __webpack_require__("qfzM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc0a7558"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuestrosComienzos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc0a7558_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nuestrosComienzos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z1q/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CabeceraEN__ = __webpack_require__("DPbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PieEN__ = __webpack_require__("LKlI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'proveedores',
  components: {
    CabeceraEN: __WEBPACK_IMPORTED_MODULE_0__components_CabeceraEN__["a" /* default */],
    PieEN: __WEBPACK_IMPORTED_MODULE_1__components_PieEN__["a" /* default */]
  }
});



/***/ }),

/***/ "zDh6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQwNjNFNTUxRTk2NDExRUI4MDg3RjNDNzdEQkRDMjVCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQwNjNFNTUyRTk2NDExRUI4MDg3RjNDNzdEQkRDMjVCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDA2M0U1NEZFOTY0MTFFQjgwODdGM0M3N0RCREMyNUIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDA2M0U1NTBFOTY0MTFFQjgwODdGM0M3N0RCREMyNUIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7PcNLbAAABDUlEQVR42mJkQAa+88SBZA4QewCxMlT0PhDvBOLJDJuTnsOUMiJpCgeSs4GYlwE7+ArE6UDNSxEafecFAMn1DMSBMKDm1YxATUJAzhsU2xkY2oDYEogdcWgWZwISpWiaQOAQ0FQnIH0Zh8ZKkMYALBI7gC6JBGrWA7IvYpH3AWmUx2HqMqDmHKBmAyD7NJqcFBOBgGCF0v/QxBlBGh/h0BQPtK0faOspINscTe4ZSOMmbH4AaloE1HQWyDbFIr8NFB0iQMZrNIkWILYAYhccrpGEJYBQILmKyAQQDXTNMkjgAFMCkIwB4u94NPwC4kSQJgaMiPedJwMk84DYFRpNIPmHQLwHmsgfwpQCBBgAJDE+I5nn3ZQAAAAASUVORK5CYII="

/***/ }),

/***/ "zDiD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__ = __webpack_require__("g4dN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_owl_carousel_dist_assets_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel__ = __webpack_require__("YiUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pie__ = __webpack_require__("iPQG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'quienesSomos',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.zurda > ul').owlCarousel({
      autoplay: true,
      items: 1,
      loop: true,
      slideSpeed: 1000,
      autoplaySpeed: 500,
      singleItem: true,
      dragBeforeAnimFinish: false,
      mouseDrag: true,
      touchDrag: true,
      nav: false
    });
  },
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_3__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_4__components_Pie__["a" /* default */]
  }
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.primer-btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop').addClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.second-btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop1').addClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tercer-btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop2').addClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cuarto-btn').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop3').addClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop').removeClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop1').removeClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop2').removeClass('act-pop');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close').click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop3').removeClass('act-pop');
  });
});

/***/ }),

/***/ "zeFF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__ = __webpack_require__("SDdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Pie__ = __webpack_require__("iPQG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lineaEtica',
  components: {
    Cabecera: __WEBPACK_IMPORTED_MODULE_0__components_Cabecera__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_1__components_Pie__["a" /* default */]
  }
});



/***/ }),

/***/ "zg+3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.09e5667.jpg";

/***/ }),

/***/ "ziWI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.5977a7b.jpg";

/***/ }),

/***/ "zsly":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cabecera.4d8de50.jpg";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.634b41c59dd34c692e26.js